import * as i0 from '@angular/core';
import { Injectable, inject, Component, ChangeDetectionStrategy, Optional, NgModule, EventEmitter, Input, Output, isDevMode, Pipe } from '@angular/core';
import * as i2$1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i3 from '@angular/router';
import { RouterModule } from '@angular/router';
import { CartValidationGuard } from '@spartacus/cart/base/core';
import * as i1$1 from '@spartacus/core';
import { BaseSiteService, getLastValueSync, FeatureConfigService, WindowRef, GlobalMessageType, I18nModule, FeaturesConfigModule, provideDefaultConfig, GlobalMessageService, UserPaymentService, UserAddressService, TranslationService, CurrencyService, LanguageService, UrlModule, LoggerService, useFeatureStyles } from '@spartacus/core';
import * as i4 from '@spartacus/storefront';
import { SelectFocusUtility, getAddressNumbers, CardModule, SpinnerModule, OutletModule, PageComponentModule, CustomFormValidators, FormErrorsModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, LaunchDialogService, LAUNCH_CALLER, NgSelectA11yModule, IconModule, ICON_TYPE, SpinnerComponent, DIALOG_TYPE, AtMessageModule, PromotionsModule } from '@spartacus/storefront';
import * as i7 from '@spartacus/user/profile/components';
import { AddressFormModule } from '@spartacus/user/profile/components';
import { map, take, filter, switchMap, debounceTime, tap, catchError, distinctUntilChanged, withLatestFrom } from 'rxjs/operators';
import * as i1 from '@spartacus/cart/base/root';
import { CartOutlets, PromotionLocation } from '@spartacus/cart/base/root';
import { combineLatest, BehaviorSubject, of, tap as tap$1, filter as filter$1, map as map$1, switchMap as switchMap$1, EMPTY, Subscription, Observable, take as take$1 } from 'rxjs';
import * as i2 from '@spartacus/checkout/base/root';
import { CheckoutConfig, DeliveryModePreferences, CheckoutStepType, CheckoutDeliveryAddressFacade, CheckoutStepState } from '@spartacus/checkout/base/root';
import * as i3$1 from '@angular/forms';
import { Validators, ReactiveFormsModule, FormsModule, UntypedFormBuilder } from '@angular/forms';
import * as i4$1 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i1$2 from '@spartacus/order/root';
import { deliveryAddressCard, deliveryModeCard, paymentMethodCard, billingAddressCard } from '@spartacus/order/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function CheckoutDeliveryAddressComponent_section_0_ng_template_2_Template(rf, ctx) {}
function CheckoutDeliveryAddressComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section");
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtemplate(2, CheckoutDeliveryAddressComponent_section_0_ng_template_2_Template, 0, 0, "ng-template", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r1 = i0.ɵɵreference(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "checkoutAddress.shippingAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", content_r1);
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "div", 23);
    i0.ɵɵlistener("click", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_div_8_Template_div_click_1_listener() {
      const card_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.selectAddress(card_r5.address));
    });
    i0.ɵɵelementStart(2, "cx-card", 24);
    i0.ɵɵlistener("sendCard", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_div_8_Template_cx_card_sendCard_2_listener() {
      const card_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.selectAddress(card_r5.address));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const card_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("border", true)("index", i_r6)("fitToContainer", true)("content", card_r5.card)("role", "group");
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13)(4, "button", 14);
    i0.ɵɵlistener("click", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.showNewAddressForm());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 15);
    i0.ɵɵtemplate(8, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_div_8_Template, 3, 5, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 17)(10, "button", 14);
    i0.ɵɵlistener("click", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.showNewAddressForm());
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 18)(14, "div", 19)(15, "button", 20);
    i0.ɵɵlistener("click", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.back());
    });
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 19)(19, "button", 21);
    i0.ɵɵpipe(20, "async");
    i0.ɵɵlistener("click", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_Template_button_click_19_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.next());
    });
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_14_0;
    const cards_r7 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 7, "checkoutAddress.selectYourDeliveryAddress"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 9, "checkoutAddress.addNewAddress"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", cards_r7);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 11, "checkoutAddress.addNewAddress"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 13, ctx_r2.backBtnText), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !((tmp_14_0 = i0.ɵɵpipeBind1(20, 15, ctx_r2.selectedAddress$)) == null ? null : tmp_14_0.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 17, "common.continue"), " ");
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_cx_address_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-address-form", 26);
    i0.ɵɵlistener("backToAddress", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_cx_address_form_0_Template_cx_address_form_backToAddress_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.hideNewAddressForm(false));
    })("submitAddress", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_cx_address_form_0_Template_cx_address_form_submitAddress_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.addAddress($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("showTitleCode", true);
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-address-form", 27);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("backToAddress", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_ng_template_1_Template_cx_address_form_backToAddress_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.hideNewAddressForm(true));
    })("submitAddress", function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_ng_template_1_Template_cx_address_form_submitAddress_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.addAddress($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate("cancelBtnLabel", i0.ɵɵpipeBind1(1, 4, ctx_r2.backBtnText));
    i0.ɵɵproperty("showTitleCode", true)("setAsDefaultField", !ctx_r2.isGuestCheckout)("addressData", ctx_r2.selectedAddress);
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_cx_address_form_0_Template, 1, 1, "cx-address-form", 25)(1, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_ng_template_1_Template, 2, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const initialAddressForm_r10 = i0.ɵɵreference(2);
    const cards_r7 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("ngIf", cards_r7.length)("ngIfElse", initialAddressForm_r10);
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_div_1_Template, 2, 3, "div", 9)(2, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 10)(3, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_3_Template, 23, 19, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(5, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_ng_template_5_Template, 3, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const showExistingAddresses_r11 = i0.ɵɵreference(4);
    const newAddressForm_r12 = i0.ɵɵreference(6);
    const cards_r7 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (cards_r7 == null ? null : cards_r7.length) && !ctx_r2.addressFormOpened)("ngIfThen", showExistingAddresses_r11)("ngIfElse", newAddressForm_r12);
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_ng_container_1_Template, 7, 4, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    const loading_r13 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx_r2.isUpdating$))("ngIfElse", loading_r13);
  }
}
function CheckoutDeliveryAddressComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 7);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CheckoutDeliveryAddressComponent_ng_template_1_ng_container_3_Template, 3, 4, "ng-container", 8);
    i0.ɵɵpipe(4, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "checkoutAddress.shippingAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r2.cards$));
  }
}
function CheckoutDeliveryAddressComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c0 = a0 => ({
  item: a0
});
const _c1 = a0 => ({
  items: a0,
  readonly: true
});
function CheckoutDeliveryModeComponent_fieldset_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "legend", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "checkoutMode.deliveryMethod"), " ");
  }
}
function CheckoutDeliveryModeComponent_fieldset_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "legend", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "checkoutMode.deliveryOptions"), " ");
  }
}
function CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "input", 18);
    i0.ɵɵlistener("change", function CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_div_3_Template_input_change_1_listener($event) {
      const mode_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.changeMode(mode_r3.code, $event));
    })("click", function CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_div_3_Template_input_click_1_listener($event) {
      const mode_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.changeMode(mode_r3.code, $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 19)(3, "div", 20);
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "span", 21);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 22);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "div", 23);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const mode_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "deliveryMode-", mode_r3.code, "");
    i0.ɵɵproperty("value", mode_r3.code);
    i0.ɵɵattribute("aria-checked", ctx_r3.getAriaChecked(mode_r3.code))("aria-label", mode_r3.name + " " + mode_r3.description + " " + (mode_r3.deliveryCost == null ? null : mode_r3.deliveryCost.formattedValue));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "deliveryMode-", mode_r3.code, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", mode_r3.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(", mode_r3.description, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", mode_r3.deliveryCost == null ? null : mode_r3.deliveryCost.formattedValue, " ");
  }
}
function CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_ng_template_4_Template(rf, ctx) {}
function CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_div_1_Template, 2, 3, "div", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtemplate(3, CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_div_3_Template, 10, 10, "div", 14)(4, CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_ng_template_4_Template, 0, 0, "ng-template", 15);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const supportedDeliveryModes_r5 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r3.mode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", supportedDeliveryModes_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r3.CartOutlets.DELIVERY_MODE)("cxOutletContext", i0.ɵɵpureFunction1(7, _c0, i0.ɵɵpipeBind1(5, 5, ctx_r3.activeCartFacade.getActive())));
  }
}
function CheckoutDeliveryModeComponent_fieldset_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 9);
    i0.ɵɵtemplate(1, CheckoutDeliveryModeComponent_fieldset_2_ng_container_1_Template, 4, 3, "ng-container", 2)(2, CheckoutDeliveryModeComponent_fieldset_2_ng_container_2_Template, 4, 3, "ng-container", 2)(3, CheckoutDeliveryModeComponent_fieldset_2_ng_container_3_Template, 6, 9, "ng-container", 10);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const loading_r6 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!showDeliveryOptionsTranslation");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "showDeliveryOptionsTranslation");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 4, ctx_r3.isUpdating$) && i0.ɵɵpipeBind1(5, 6, ctx_r3.supportedDeliveryModes$))("ngIfElse", loading_r6);
  }
}
function CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "input", 24);
    i0.ɵɵlistener("change", function CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_div_4_Template_input_change_1_listener($event) {
      const mode_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.changeMode(mode_r8.code, $event));
    })("click", function CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_div_4_Template_input_click_1_listener($event) {
      const mode_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.changeMode(mode_r8.code, $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 25)(3, "div", 20);
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "span", 21);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 22);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "div", 23);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const mode_r8 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "deliveryMode-", mode_r8.code, "");
    i0.ɵɵproperty("value", mode_r8.code);
    i0.ɵɵattribute("aria-checked", ctx_r3.getAriaChecked(mode_r8.code));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "deliveryMode-", mode_r8.code, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", mode_r8.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(", mode_r8.description, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", mode_r8.deliveryCost == null ? null : mode_r8.deliveryCost.formattedValue, " ");
  }
}
function CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_ng_template_5_Template(rf, ctx) {}
function CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_div_1_Template, 2, 3, "div", 12);
    i0.ɵɵelementStart(2, "div", 13)(3, "div", 9);
    i0.ɵɵtemplate(4, CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_div_4_Template, 10, 9, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_ng_template_5_Template, 0, 0, "ng-template", 15);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const supportedDeliveryModes_r9 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r3.mode);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", supportedDeliveryModes_r9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r3.CartOutlets.DELIVERY_MODE)("cxOutletContext", i0.ɵɵpureFunction1(7, _c0, i0.ɵɵpipeBind1(6, 5, ctx_r3.activeCartFacade.getActive())));
  }
}
function CheckoutDeliveryModeComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CheckoutDeliveryModeComponent_ng_container_3_ng_container_4_Template, 7, 9, "ng-container", 10);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const loading_r6 = i0.ɵɵreference(7);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "checkoutMode.deliveryMethod"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(5, 5, ctx_r3.isUpdating$) && i0.ɵɵpipeBind1(6, 7, ctx_r3.supportedDeliveryModes$))("ngIfElse", loading_r6);
  }
}
function CheckoutDeliveryModeComponent_ng_container_4_ng_template_4_Template(rf, ctx) {}
function CheckoutDeliveryModeComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 11);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CheckoutDeliveryModeComponent_ng_container_4_ng_template_4_Template, 0, 0, "ng-template", 15);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "checkoutMode.deliveryEntries"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r3.CartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction1(7, _c1, i0.ɵɵpipeBind1(5, 5, ctx_r3.activeCartFacade.getDeliveryEntries())));
  }
}
function CheckoutDeliveryModeComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c2 = a0 => ({
  label: a0
});
function CheckoutLoginComponent_cx_form_errors_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 9);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "checkoutLogin.emailAddress.label")))("control", ctx_r0.checkoutLoginForm.get("email"));
  }
}
function CheckoutLoginComponent_cx_form_errors_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.checkoutLoginForm.get("email"));
  }
}
function CheckoutLoginComponent_cx_form_errors_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 11);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "checkoutLogin.confirmEmail.label")))("control", ctx_r0.checkoutLoginForm.get("emailConfirmation"));
  }
}
function CheckoutLoginComponent_cx_form_errors_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("control", ctx_r0.checkoutLoginForm.get("emailConfirmation"));
  }
}
function CheckoutOrderSummaryComponent_ng_template_0_Template(rf, ctx) {}
const _c3 = () => ({
  required: "true"
});
const _c4 = a0 => ({
  ariaLabel: a0
});
function CheckoutBillingAddressFormComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5)(2, "div", 6)(3, "label")(4, "input", 7);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵlistener("change", function CheckoutBillingAddressFormComponent_ng_container_4_Template_input_change_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleSameAsDeliveryAddress());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 8);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r1.sameAsDeliveryAddress);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 3, "paymentForm.billingAddressSameAsShipping"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, "paymentForm.sameAsDeliveryAddress"));
  }
}
function CheckoutBillingAddressFormComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-card", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const deliveryAddress_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", ctx_r1.getAddressCardContent(deliveryAddress_r3));
  }
}
function CheckoutBillingAddressFormComponent_ng_template_8_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "span", 12);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelement(5, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-select", 28);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵlistener("change", function CheckoutBillingAddressFormComponent_ng_template_8_ng_container_3_div_1_Template_ng_select_change_6_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.countrySelected($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "cx-form-errors", 29);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_12_0;
    const countries_r5 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 10, "addressForm.country"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 12, "addressForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(16, _c3))("searchable", true)("clearable", false)("items", countries_r5)("cxNgSelectA11y", i0.ɵɵpureFunction1(17, _c4, i0.ɵɵpipeBind1(8, 14, "addressForm.country")));
    i0.ɵɵattribute("aria-invalid", ((tmp_12_0 = ctx_r1.billingAddressForm.get("isocode")) == null ? null : tmp_12_0.touched) && ((tmp_12_0 = ctx_r1.billingAddressForm.get("isocode")) == null ? null : tmp_12_0.invalid))("aria-errormessage", "isocodeError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("country.isocode"));
  }
}
function CheckoutBillingAddressFormComponent_ng_template_8_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutBillingAddressFormComponent_ng_template_8_ng_container_3_div_1_Template, 10, 19, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const countries_r5 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", countries_r5.length !== 0);
  }
}
function CheckoutBillingAddressFormComponent_ng_template_8_ng_container_58_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22)(2, "label")(3, "span", 12);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "ng-select", 31);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelement(9, "cx-form-errors", 32);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_14_0;
    const regions_r6 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 12, "addressForm.state"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("bindLabel", regions_r6[0].name ? "name" : "isocodeShort");
    i0.ɵɵpropertyInterpolate("bindValue", regions_r6[0].name ? "isocodeShort" : "region");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 14, "addressForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(18, _c3))("searchable", true)("clearable", false)("items", regions_r6)("cxNgSelectA11y", i0.ɵɵpureFunction1(19, _c4, i0.ɵɵpipeBind1(8, 16, "addressForm.state")));
    i0.ɵɵattribute("aria-invalid", ((tmp_14_0 = ctx_r1.billingAddressForm.get("isocodeShort")) == null ? null : tmp_14_0.touched) && ((tmp_14_0 = ctx_r1.billingAddressForm.get("isocodeShort")) == null ? null : tmp_14_0.invalid))("aria-errormessage", "isocodeShortError");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("region.isocodeShort"));
  }
}
function CheckoutBillingAddressFormComponent_ng_template_8_ng_container_58_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 30);
    i0.ɵɵtemplate(1, CheckoutBillingAddressFormComponent_ng_template_8_ng_container_58_ng_container_1_Template, 10, 21, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const regions_r6 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", regions_r6.length !== 0);
  }
}
function CheckoutBillingAddressFormComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "cx-form-required-legend");
    i0.ɵɵelementStart(2, "div", 11);
    i0.ɵɵtemplate(3, CheckoutBillingAddressFormComponent_ng_template_8_ng_container_3_Template, 2, 1, "ng-container", 3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5)(6, "label")(7, "span", 12);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelement(10, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(11, "input", 13);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelement(13, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 5)(15, "label")(16, "span", 12);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelement(19, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "input", 15);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵelement(22, "cx-form-errors", 16);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "div", 5)(24, "label")(25, "span", 12);
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelement(28, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(29, "input", 17);
    i0.ɵɵpipe(30, "cxTranslate");
    i0.ɵɵelement(31, "cx-form-errors", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 5)(33, "label")(34, "span", 19);
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "input", 20);
    i0.ɵɵpipe(38, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(39, "div", 21)(40, "div", 22)(41, "label")(42, "span", 12);
    i0.ɵɵtext(43);
    i0.ɵɵpipe(44, "cxTranslate");
    i0.ɵɵelement(45, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(46, "input", 23);
    i0.ɵɵpipe(47, "cxTranslate");
    i0.ɵɵelement(48, "cx-form-errors", 24);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(49, "div", 22)(50, "label")(51, "span", 12);
    i0.ɵɵtext(52);
    i0.ɵɵpipe(53, "cxTranslate");
    i0.ɵɵelement(54, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(55, "input", 25);
    i0.ɵɵpipe(56, "cxTranslate");
    i0.ɵɵelement(57, "cx-form-errors", 26);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(58, CheckoutBillingAddressFormComponent_ng_template_8_ng_container_58_Template, 2, 1, "ng-container", 27);
    i0.ɵɵpipe(59, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_6_0;
    let tmp_11_0;
    let tmp_16_0;
    let tmp_23_0;
    let tmp_28_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.billingAddressForm);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 30, ctx_r1.countries$));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 32, "addressForm.firstName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(12, 34, "addressForm.firstName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_6_0 = ctx_r1.billingAddressForm.get("firstName")) == null ? null : tmp_6_0.touched) && ((tmp_6_0 = ctx_r1.billingAddressForm.get("firstName")) == null ? null : tmp_6_0.invalid))("aria-errormessage", "firstNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("firstName"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 36, "addressForm.lastName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 38, "addressForm.lastName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_11_0 = ctx_r1.billingAddressForm.get("lastName")) == null ? null : tmp_11_0.touched) && ((tmp_11_0 = ctx_r1.billingAddressForm.get("lastName")) == null ? null : tmp_11_0.invalid))("aria-errormessage", "lastNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("lastName"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 40, "addressForm.address1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(30, 42, "addressForm.streetAddress"));
    i0.ɵɵattribute("aria-invalid", ((tmp_16_0 = ctx_r1.billingAddressForm.get("line1")) == null ? null : tmp_16_0.touched) && ((tmp_16_0 = ctx_r1.billingAddressForm.get("line1")) == null ? null : tmp_16_0.invalid))("aria-errormessage", "line1Error");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("line1"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(36, 44, "addressForm.address2"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(38, 46, "addressForm.aptSuite"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(44, 48, "addressForm.city.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(47, 50, "addressForm.city.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_23_0 = ctx_r1.billingAddressForm.get("town")) == null ? null : tmp_23_0.touched) && ((tmp_23_0 = ctx_r1.billingAddressForm.get("town")) == null ? null : tmp_23_0.invalid))("aria-errormessage", "townError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("town"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(53, 52, "addressForm.zipCode.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(56, 54, "addressForm.zipCode.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_28_0 = ctx_r1.billingAddressForm.get("postalCode")) == null ? null : tmp_28_0.touched) && ((tmp_28_0 = ctx_r1.billingAddressForm.get("postalCode")) == null ? null : tmp_28_0.invalid))("aria-errormessage", "postalCodeError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("postalCode"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(59, 56, ctx_r1.regions$));
  }
}
const _c5 = a0 => ({
  selected: a0
});
function CheckoutPaymentFormComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 33);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_ng_container_7_div_1_cx_form_errors_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 36);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "paymentForm.paymentType")))("control", ctx_r1.paymentForm.get("cardType.code"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_ng_container_7_div_1_cx_form_errors_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("control", ctx_r1.paymentForm.get("cardType.code"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_ng_container_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "span", 34);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelement(5, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "ng-select", 35);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵtemplate(9, CheckoutPaymentFormComponent_ng_container_0_ng_container_7_div_1_cx_form_errors_9_Template, 2, 6, "cx-form-errors", 21)(10, CheckoutPaymentFormComponent_ng_container_0_ng_container_7_div_1_cx_form_errors_10_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const cardTypes_r3 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(4, 9, "paymentForm.paymentType"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 11, "paymentForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(15, _c3))("searchable", true)("clearable", false)("items", cardTypes_r3)("cxNgSelectA11y", i0.ɵɵpureFunction1(16, _c4, i0.ɵɵpipeBind1(8, 13, "paymentForm.paymentType")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
  }
}
function CheckoutPaymentFormComponent_ng_container_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutPaymentFormComponent_ng_container_0_ng_container_7_div_1_Template, 11, 18, "div", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cardTypes_r3 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", cardTypes_r3.length !== 0);
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 38);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "paymentForm.accountHolderName.label")))("control", ctx_r1.paymentForm.get("accountHolderName"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.paymentForm.get("accountHolderName"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 39);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "paymentForm.cardNumber")))("control", ctx_r1.paymentForm.get("cardNumber"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.paymentForm.get("cardNumber"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_39_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 36);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "paymentForm.expirationDate")))("control", ctx_r1.paymentForm.get("expiryMonth"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.paymentForm.get("expiryMonth"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_45_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 36);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "paymentForm.expirationDate")))("control", ctx_r1.paymentForm.get("expiryYear"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.paymentForm.get("expiryYear"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_57_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 40);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "paymentForm.securityCode")))("control", ctx_r1.paymentForm.get("cvn"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_58_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("control", ctx_r1.paymentForm.get("cvn"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_59_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 41)(2, "label")(3, "input", 42);
    i0.ɵɵlistener("change", function CheckoutPaymentFormComponent_ng_container_0_div_59_Template_input_change_3_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleDefaultPaymentMethod());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 43);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 1, "paymentForm.setAsDefault"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "div", 41)(3, "label")(4, "input", 46);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵlistener("change", function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_container_4_Template_input_change_4_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggleSameAsDeliveryAddress());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 43);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r1.sameAsDeliveryAddress);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 3, "paymentForm.billingAddressSameAsShipping"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, "paymentForm.sameAsDeliveryAddress"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-card", 47);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const deliveryAddress_r6 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", ctx_r1.getAddressCardContent(deliveryAddress_r6));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_div_1_cx_form_errors_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 36);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.country")))("control", ctx_r1.billingAddressForm.get("country.isocode"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_div_1_cx_form_errors_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("country.isocode"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "span", 34);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelement(5, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-select", 63);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵlistener("change", function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_div_1_Template_ng_select_change_6_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.countrySelected($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_div_1_cx_form_errors_9_Template, 2, 6, "cx-form-errors", 21)(10, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_div_1_cx_form_errors_10_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const countries_r8 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 9, "addressForm.country"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 11, "addressForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(15, _c3))("searchable", true)("clearable", false)("items", countries_r8)("cxNgSelectA11y", i0.ɵɵpureFunction1(16, _c4, i0.ɵɵpipeBind1(8, 13, "addressForm.country")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_div_1_Template, 11, 18, "div", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const countries_r8 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", countries_r8.length !== 0);
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 64);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.firstName.label")))("control", ctx_r1.billingAddressForm.get("firstName"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("firstName"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 65);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.lastName.label")))("control", ctx_r1.billingAddressForm.get("lastName"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("lastName"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 66);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.address1")))("control", ctx_r1.billingAddressForm.get("line1"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_33_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("line1"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_50_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 67);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.city.label")))("control", ctx_r1.billingAddressForm.get("town"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_51_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("town"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_60_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 68);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.zipCode.label")))("control", ctx_r1.billingAddressForm.get("postalCode"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_61_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("postalCode"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_62_ng_container_1_cx_form_errors_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 36);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(4, _c2, i0.ɵɵpipeBind1(1, 2, "addressForm.state")))("control", ctx_r1.billingAddressForm.get("region.isocodeShort"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_62_ng_container_1_cx_form_errors_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-form-errors", 37);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("control", ctx_r1.billingAddressForm.get("region.isocodeShort"));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_62_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 57)(2, "label")(3, "span", 34);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "ng-select", 70);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵtemplate(9, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_62_ng_container_1_cx_form_errors_9_Template, 2, 6, "cx-form-errors", 21)(10, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_62_ng_container_1_cx_form_errors_10_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const regions_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 11, "addressForm.state"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("bindLabel", regions_r9[0].name ? "name" : "isocodeShort");
    i0.ɵɵpropertyInterpolate("bindValue", regions_r9[0].name ? "isocodeShort" : "region");
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 13, "addressForm.selectOne"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(17, _c3))("searchable", true)("clearable", false)("items", regions_r9)("cxNgSelectA11y", i0.ɵɵpureFunction1(18, _c4, i0.ɵɵpipeBind1(8, 15, "addressForm.state")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_62_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 69);
    i0.ɵɵtemplate(1, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_62_ng_container_1_Template, 11, 20, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const regions_r9 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", regions_r9.length !== 0);
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 48)(1, "div", 49);
    i0.ɵɵtemplate(2, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_2_Template, 2, 1, "ng-container", 9);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 10)(5, "label")(6, "span", 34);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelement(9, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "input", 50);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵtemplate(12, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_12_Template, 2, 6, "cx-form-errors", 51)(13, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_13_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 10)(15, "label")(16, "span", 34);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelement(19, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(20, "input", 52);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵtemplate(22, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_22_Template, 2, 6, "cx-form-errors", 53)(23, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_23_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 10)(25, "label")(26, "span", 34);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "cxTranslate");
    i0.ɵɵelement(29, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "input", 54);
    i0.ɵɵpipe(31, "cxTranslate");
    i0.ɵɵtemplate(32, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_32_Template, 2, 6, "cx-form-errors", 55)(33, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_33_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 10)(35, "label")(36, "span", 11);
    i0.ɵɵtext(37);
    i0.ɵɵpipe(38, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(39, "input", 56);
    i0.ɵɵpipe(40, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(41, "div", 6)(42, "div", 57)(43, "label")(44, "span", 34);
    i0.ɵɵtext(45);
    i0.ɵɵpipe(46, "cxTranslate");
    i0.ɵɵelement(47, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(48, "input", 58);
    i0.ɵɵpipe(49, "cxTranslate");
    i0.ɵɵtemplate(50, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_50_Template, 2, 6, "cx-form-errors", 59)(51, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_51_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(52, "div", 57)(53, "label")(54, "span", 34);
    i0.ɵɵtext(55);
    i0.ɵɵpipe(56, "cxTranslate");
    i0.ɵɵelement(57, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(58, "input", 60);
    i0.ɵɵpipe(59, "cxTranslate");
    i0.ɵɵtemplate(60, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_60_Template, 2, 6, "cx-form-errors", 61)(61, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_cx_form_errors_61_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(62, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_ng_container_62_Template, 2, 1, "ng-container", 62);
    i0.ɵɵpipe(63, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_10_0;
    let tmp_16_0;
    let tmp_22_0;
    let tmp_30_0;
    let tmp_36_0;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formGroup", ctx_r1.billingAddressForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 35, ctx_r1.countries$));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 37, "addressForm.firstName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(11, 39, "addressForm.firstName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_10_0 = ctx_r1.billingAddressForm.get("firstName")) == null ? null : tmp_10_0.touched) && ((tmp_10_0 = ctx_r1.billingAddressForm.get("firstName")) == null ? null : tmp_10_0.invalid))("aria-errormessage", "firstNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 41, "addressForm.lastName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(21, 43, "addressForm.lastName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_16_0 = ctx_r1.billingAddressForm.get("lastName")) == null ? null : tmp_16_0.touched) && ((tmp_16_0 = ctx_r1.billingAddressForm.get("lastName")) == null ? null : tmp_16_0.invalid))("aria-errormessage", "lastNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(28, 45, "addressForm.address1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(31, 47, "addressForm.streetAddress"));
    i0.ɵɵattribute("aria-invalid", ((tmp_22_0 = ctx_r1.billingAddressForm.get("line1")) == null ? null : tmp_22_0.touched) && ((tmp_22_0 = ctx_r1.billingAddressForm.get("line1")) == null ? null : tmp_22_0.invalid))("aria-errormessage", "line1Error");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(38, 49, "addressForm.address2"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(40, 51, "addressForm.aptSuite"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(46, 53, "addressForm.city.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(49, 55, "addressForm.city.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_30_0 = ctx_r1.billingAddressForm.get("town")) == null ? null : tmp_30_0.touched) && ((tmp_30_0 = ctx_r1.billingAddressForm.get("town")) == null ? null : tmp_30_0.invalid))("aria-errormessage", "townError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(56, 57, "addressForm.zipCode.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(59, 59, "addressForm.zipCode.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_36_0 = ctx_r1.billingAddressForm.get("postalCode")) == null ? null : tmp_36_0.touched) && ((tmp_36_0 = ctx_r1.billingAddressForm.get("postalCode")) == null ? null : tmp_36_0.invalid))("aria-errormessage", "postalCodeError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(63, 61, ctx_r1.regions$));
  }
}
function CheckoutPaymentFormComponent_ng_container_0_div_60_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44)(1, "div", 45);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_container_4_Template, 9, 7, "ng-container", 9);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵtemplate(6, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_container_6_Template, 2, 1, "ng-container", 3);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵtemplate(8, CheckoutPaymentFormComponent_ng_container_0_div_60_ng_template_8_Template, 64, 63, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const billingAddress_r10 = i0.ɵɵreference(9);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "paymentForm.billingAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 6, ctx_r1.showSameAsDeliveryAddressCheckbox$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.sameAsDeliveryAddress && i0.ɵɵpipeBind1(7, 8, ctx_r1.deliveryAddress$))("ngIfElse", billingAddress_r10);
  }
}
function CheckoutPaymentFormComponent_ng_container_0_button_63_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 71);
    i0.ɵɵlistener("click", function CheckoutPaymentFormComponent_ng_container_0_button_63_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.back());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "common.back"), " ");
  }
}
function CheckoutPaymentFormComponent_ng_container_0_button_64_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 71);
    i0.ɵɵlistener("click", function CheckoutPaymentFormComponent_ng_container_0_button_64_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "paymentForm.changePayment"), " ");
  }
}
function CheckoutPaymentFormComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutPaymentFormComponent_ng_container_0_div_1_Template, 2, 3, "div", 4);
    i0.ɵɵelement(2, "cx-form-required-legend");
    i0.ɵɵelementStart(3, "form", 5);
    i0.ɵɵlistener("ngSubmit", function CheckoutPaymentFormComponent_ng_container_0_Template_form_ngSubmit_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.next());
    });
    i0.ɵɵelementStart(4, "div", 6)(5, "div", 7)(6, "div", 8);
    i0.ɵɵtemplate(7, CheckoutPaymentFormComponent_ng_container_0_ng_container_7_Template, 2, 1, "ng-container", 9);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 10)(10, "label")(11, "span", 11);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelement(14, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(15, "input", 12);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵtemplate(17, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_17_Template, 2, 6, "cx-form-errors", 13)(18, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_18_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 10)(20, "label")(21, "span", 11);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "cxTranslate");
    i0.ɵɵelement(24, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(25, "input", 15);
    i0.ɵɵtemplate(26, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_26_Template, 2, 6, "cx-form-errors", 16)(27, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_27_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "div", 6)(29, "div", 17)(30, "fieldset", 18)(31, "legend", 11);
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "cxTranslate");
    i0.ɵɵelement(34, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "label", 19);
    i0.ɵɵelement(36, "ng-select", 20);
    i0.ɵɵpipe(37, "cxTranslate");
    i0.ɵɵpipe(38, "cxTranslate");
    i0.ɵɵtemplate(39, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_39_Template, 2, 6, "cx-form-errors", 21)(40, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_40_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "label", 19);
    i0.ɵɵelement(42, "ng-select", 22);
    i0.ɵɵpipe(43, "cxTranslate");
    i0.ɵɵpipe(44, "cxTranslate");
    i0.ɵɵtemplate(45, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_45_Template, 2, 6, "cx-form-errors", 21)(46, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_46_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(47, "div", 23)(48, "label")(49, "span", 11);
    i0.ɵɵtext(50);
    i0.ɵɵpipe(51, "cxTranslate");
    i0.ɵɵelement(52, "cx-form-required-asterisks")(53, "cx-icon", 24);
    i0.ɵɵpipe(54, "cxTranslate");
    i0.ɵɵpipe(55, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(56, "input", 25);
    i0.ɵɵtemplate(57, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_57_Template, 2, 6, "cx-form-errors", 26)(58, CheckoutPaymentFormComponent_ng_container_0_cx_form_errors_58_Template, 1, 1, "cx-form-errors", 14);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(59, CheckoutPaymentFormComponent_ng_container_0_div_59_Template, 7, 3, "div", 27)(60, CheckoutPaymentFormComponent_ng_container_0_div_60_Template, 10, 10, "div", 28);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(61, "div", 29)(62, "div", 30);
    i0.ɵɵtemplate(63, CheckoutPaymentFormComponent_ng_container_0_button_63_Template, 3, 3, "button", 31)(64, CheckoutPaymentFormComponent_ng_container_0_button_64_Template, 3, 3, "button", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(65, "div", 30)(66, "button", 32);
    i0.ɵɵtext(67);
    i0.ɵɵpipe(68, "cxTranslate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_8_0;
    let tmp_13_0;
    let tmp_23_0;
    let tmp_31_0;
    let tmp_38_0;
    const ctx_r1 = i0.ɵɵnextContext();
    const showExtractedBillingAddressForm_r13 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formGroup", ctx_r1.paymentForm);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 45, ctx_r1.cardTypes$));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(13, 47, "paymentForm.accountHolderName.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(16, 49, "paymentForm.accountHolderName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_8_0 = ctx_r1.paymentForm.get("accountHolderName")) == null ? null : tmp_8_0.touched) && ((tmp_8_0 = ctx_r1.paymentForm.get("accountHolderName")) == null ? null : tmp_8_0.invalid))("aria-errormessage", "accountHolderNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(23, 51, "paymentForm.cardNumber"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-invalid", ((tmp_13_0 = ctx_r1.paymentForm.get("cardNumber")) == null ? null : tmp_13_0.touched) && ((tmp_13_0 = ctx_r1.paymentForm.get("cardNumber")) == null ? null : tmp_13_0.invalid))("aria-errormessage", "cardNumberError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(33, 53, "paymentForm.expirationDate"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(37, 55, "paymentForm.monthMask"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(73, _c3))("searchable", true)("clearable", false)("items", ctx_r1.months)("cxNgSelectA11y", i0.ɵɵpureFunction1(76, _c4, i0.ɵɵpipeBind2(38, 57, "paymentForm.expirationMonth", i0.ɵɵpureFunction1(74, _c5, (tmp_23_0 = ctx_r1.paymentForm.get("expiryMonth")) == null ? null : tmp_23_0.value))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(43, 60, "paymentForm.yearMask"));
    i0.ɵɵproperty("inputAttrs", i0.ɵɵpureFunction0(78, _c3))("searchable", true)("clearable", false)("items", ctx_r1.years)("cxNgSelectA11y", i0.ɵɵpureFunction1(81, _c4, i0.ɵɵpipeBind2(44, 62, "paymentForm.expirationYear", i0.ɵɵpureFunction1(79, _c5, (tmp_31_0 = ctx_r1.paymentForm.get("expiryYear")) == null ? null : tmp_31_0.value))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(51, 65, "paymentForm.securityCode"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(54, 67, "paymentForm.securityCodeTitle"));
    i0.ɵɵproperty("type", ctx_r1.iconTypes.INFO);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(55, 69, "paymentForm.securityCodeTitle"));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-invalid", ((tmp_38_0 = ctx_r1.paymentForm.get("cvn")) == null ? null : tmp_38_0.touched) && ((tmp_38_0 = ctx_r1.paymentForm.get("cvn")) == null ? null : tmp_38_0.invalid))("aria-errormessage", "cvnError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.setAsDefaultField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.useExtractedBillingAddressComponent)("ngIfElse", showExtractedBillingAddressForm_r13);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentMethodsCount === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.paymentMethodsCount > 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(68, 71, "common.continue"), " ");
  }
}
function CheckoutPaymentFormComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner");
  }
}
function CheckoutPaymentFormComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-checkout-billing-address-form");
  }
}
function CheckoutPaymentMethodComponent_section_0_ng_template_2_Template(rf, ctx) {}
function CheckoutPaymentMethodComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section");
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtemplate(2, CheckoutPaymentMethodComponent_section_0_ng_template_2_Template, 0, 0, "ng-template", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const content_r1 = i0.ɵɵreference(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "paymentForm.payment"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", content_r1);
  }
}
function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_container_1_div_1_Template, 2, 3, "div", 8)(2, CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cards_r2 = i0.ɵɵnextContext().ngIf;
    const hasExistingPaymentMethods_r3 = i0.ɵɵreference(4);
    const newPaymentForm_r4 = i0.ɵɵreference(6);
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (cards_r2 == null ? null : cards_r2.length) && !ctx_r4.newPaymentFormManuallyOpened)("ngIfThen", hasExistingPaymentMethods_r3)("ngIfElse", newPaymentForm_r4);
  }
}
function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵlistener("click", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_div_8_Template_div_click_1_listener() {
      const card_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r4 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r4.selectPaymentMethod(card_r8.paymentMethod));
    });
    i0.ɵɵelementStart(2, "cx-card", 22);
    i0.ɵɵlistener("sendCard", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_div_8_Template_cx_card_sendCard_2_listener() {
      const card_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r4 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r4.selectPaymentMethod(card_r8.paymentMethod));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const card_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("border", true)("fitToContainer", true)("content", card_r8.content)("index", i_r9);
  }
}
function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12)(4, "button", 13);
    i0.ɵɵlistener("click", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.showNewPaymentForm());
    });
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 14);
    i0.ɵɵtemplate(8, CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_div_8_Template, 3, 4, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 16)(10, "button", 13);
    i0.ɵɵlistener("click", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.showNewPaymentForm());
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 17)(14, "div", 18)(15, "button", 13);
    i0.ɵɵlistener("click", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.back());
    });
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "div", 18)(19, "button", 19);
    i0.ɵɵpipe(20, "async");
    i0.ɵɵlistener("click", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_Template_button_click_19_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.next());
    });
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_13_0;
    const cards_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 7, "paymentForm.choosePaymentMethod"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 9, "paymentForm.addNewPayment"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", cards_r2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 11, "paymentForm.addNewPayment"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 13, ctx_r4.backBtnText), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !((tmp_13_0 = i0.ɵɵpipeBind1(20, 15, ctx_r4.selectedMethod$)) == null ? null : tmp_13_0.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 17, "common.continue"), " ");
  }
}
function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-payment-form", 23);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("setPaymentDetails", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_5_Template_cx_payment_form_setPaymentDetails_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.setPaymentDetails($event));
    })("closeForm", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_5_Template_cx_payment_form_closeForm_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.hideNewPaymentForm());
    })("goBack", function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_5_Template_cx_payment_form_goBack_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r4 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r4.back());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const cards_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("paymentMethodsCount", (cards_r2 == null ? null : cards_r2.length) || 0)("setAsDefaultField", !ctx_r4.isGuestCheckout && !!(cards_r2 == null ? null : cards_r2.length))("loading", i0.ɵɵpipeBind1(1, 4, ctx_r4.isUpdating$))("paymentDetails", ctx_r4.paymentDetails);
  }
}
function CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_container_1_Template, 3, 4, "ng-container", 4);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_3_Template, 23, 19, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(5, CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_ng_template_5_Template, 2, 6, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    const loading_r11 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx_r4.isUpdating$))("ngIfElse", loading_r11);
  }
}
function CheckoutPaymentMethodComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CheckoutPaymentMethodComponent_ng_template_1_ng_container_3_Template, 7, 4, "ng-container", 7);
    i0.ɵɵpipe(4, "async");
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "paymentForm.payment"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r4.cards$));
  }
}
function CheckoutPaymentMethodComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c6 = a0 => [a0];
const _c7 = a0 => ({
  cxRoute: "termsAndConditions",
  params: a0
});
function CheckoutProgressMobileBottomComponent_div_0_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const step_r2 = ctx_r0.$implicit;
    const i_r3 = ctx_r0.index;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i_r3 + 1, ". ", i0.ɵɵpipeBind1(3, 2, step_r2.name), "");
  }
}
function CheckoutProgressMobileBottomComponent_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CheckoutProgressMobileBottomComponent_div_0_div_2_div_1_Template, 4, 4, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r3 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r3 > ctx_r3.activeStepIndex);
  }
}
function CheckoutProgressMobileBottomComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1);
    i0.ɵɵtemplate(2, CheckoutProgressMobileBottomComponent_div_0_div_2_Template, 2, 1, "div", 2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(3, 1, ctx_r3.steps$));
  }
}
const _c8 = a0 => ({
  count: a0
});
const _c9 = a0 => ({
  cxRoute: a0
});
function CheckoutProgressMobileTopComponent_div_0_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const cart_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(2, 2, "cartItems.cartTotal", i0.ɵɵpureFunction1(5, _c8, cart_r1.totalItems)), ": ", cart_r1.subTotal.formattedValue, " ");
  }
}
function CheckoutProgressMobileTopComponent_div_0_div_1_div_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 9);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const step_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i_r4 + 1, ". ", i0.ɵɵpipeBind1(3, 4, step_r3.name), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 6, i0.ɵɵpureFunction1(10, _c9, step_r3.routeName)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 8, "common.edit"), " ");
  }
}
function CheckoutProgressMobileTopComponent_div_0_div_1_div_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const step_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i_r4 + 1, ". ", i0.ɵɵpipeBind1(3, 2, step_r3.name), "");
  }
}
function CheckoutProgressMobileTopComponent_div_0_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CheckoutProgressMobileTopComponent_div_0_div_1_div_3_div_1_Template, 8, 12, "div", 5)(2, CheckoutProgressMobileTopComponent_div_0_div_1_div_3_div_2_Template, 4, 4, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r4 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r4 < ctx_r4.activeStepIndex);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r4 === ctx_r4.activeStepIndex);
  }
}
function CheckoutProgressMobileTopComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 1);
    i0.ɵɵtemplate(2, CheckoutProgressMobileTopComponent_div_0_div_1_div_2_Template, 3, 7, "div", 2)(3, CheckoutProgressMobileTopComponent_div_0_div_1_div_3_Template, 3, 2, "div", 3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const cart_r1 = ctx.ngIf;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (cart_r1 == null ? null : cart_r1.totalItems) && (cart_r1 == null ? null : cart_r1.subTotal));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(4, 2, ctx_r4.steps$));
  }
}
function CheckoutProgressMobileTopComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CheckoutProgressMobileTopComponent_div_0_div_1_Template, 5, 4, "div", 0);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r4.cart$));
  }
}
const _c10 = (a0, a1) => ({
  cxRoute: a0,
  params: a1
});
const _c11 = a0 => ({
  step: a0
});
function CheckoutProgressComponent_nav_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "li", 4);
    i0.ɵɵelement(2, "a", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "cxUrl");
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "cxMultiLine");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const step_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r2.isActive(i_r2))("disabled", ctx_r2.isDisabled(i_r2));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r2.isActive(i_r2))("disabled", ctx_r2.isDisabled(i_r2));
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(4, 16, i0.ɵɵpureFunction2(31, _c10, step_r1.routeName, i0.ɵɵpureFunction1(29, _c6, i0.ɵɵpipeBind1(3, 14, ctx_r2.params$)))))("tabindex", ctx_r2.getTabIndex(i_r2))("innerHTML", step_r1.nameMultiLine !== false ? i0.ɵɵpipeBind1(6, 20, i0.ɵɵpipeBind1(5, 18, step_r1.name)) : i0.ɵɵpipeBind1(7, 22, step_r1.name), i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-current", ctx_r2.isActive(i_r2) ? "step" : null)("aria-disabled", ctx_r2.isDisabled(i_r2) ? "true" : null)("aria-label", i0.ɵɵpipeBind2(9, 26, "checkoutProgress.state." + ctx_r2.getStepState(i_r2), i0.ɵɵpureFunction1(34, _c11, i0.ɵɵpipeBind1(8, 24, step_r1.name))));
  }
}
function CheckoutProgressComponent_nav_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "nav");
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵelementStart(2, "div", 1)(3, "ul", 2);
    i0.ɵɵtemplate(4, CheckoutProgressComponent_nav_0_ng_container_4_Template, 10, 36, "ng-container", 3);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "checkoutProgress.label"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(5, 4, ctx_r2.steps$));
  }
}
const _c12 = a0 => ({
  item: a0,
  readonly: true
});
const _c13 = () => [];
const _c14 = (a0, a1) => ({
  items: a0,
  readonly: true,
  promotionLocation: a1
});
function CheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const paymentMethod_r1 = i0.ɵɵreference(12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", paymentMethod_r1);
  }
}
function CheckoutReviewSubmitComponent_ng_container_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 10);
    i0.ɵɵtemplate(2, CheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 11);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const step_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", step_r2.type[0]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.checkoutStepTypePaymentDetails);
  }
}
function CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const deliveryAddress_r4 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", deliveryAddress_r4);
  }
}
function CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const deliveryMode_r5 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", deliveryMode_r5);
  }
}
function CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 10);
    i0.ɵɵtemplate(2, CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_2_Template, 2, 1, "ng-container", 11)(3, CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_3_Template, 2, 1, "ng-container", 11);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const step_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", step_r6.type[0]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.checkoutStepTypeDeliveryAddress);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.checkoutStepTypeDeliveryMode);
  }
}
function CheckoutReviewSubmitComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtemplate(2, CheckoutReviewSubmitComponent_ng_container_5_ng_container_2_Template, 3, 2, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵtemplate(4, CheckoutReviewSubmitComponent_ng_container_5_ng_container_4_Template, 4, 3, "ng-container", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const steps_r7 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.paymentSteps(steps_r7));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.deliverySteps(steps_r7));
  }
}
function CheckoutReviewSubmitComponent_ng_template_7_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "cx-card", 15);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "div", 16)(4, "a", 17);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelement(7, "cx-icon", 18);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const deliveryAddress_r8 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 4, ctx_r2.getDeliveryAddressCard(deliveryAddress_r8)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 6, i0.ɵɵpureFunction1(10, _c9, ctx_r2.getCheckoutStepUrl(ctx_r2.checkoutStepTypeDeliveryAddress))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(6, 8, "checkoutReview.editDeliveryAddressDetails"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.PENCIL);
  }
}
function CheckoutReviewSubmitComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CheckoutReviewSubmitComponent_ng_template_7_div_0_Template, 8, 12, "div", 13);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r2.deliveryAddress$));
  }
}
function CheckoutReviewSubmitComponent_ng_template_9_cx_card_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-card", 15);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const deliveryMode_r9 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(1, 1, ctx_r2.getDeliveryModeCard(deliveryMode_r9)));
  }
}
function CheckoutReviewSubmitComponent_ng_template_9_ng_template_4_Template(rf, ctx) {}
function CheckoutReviewSubmitComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div");
    i0.ɵɵtemplate(2, CheckoutReviewSubmitComponent_ng_template_9_cx_card_2_Template, 2, 3, "cx-card", 20);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, CheckoutReviewSubmitComponent_ng_template_9_ng_template_4_Template, 0, 0, "ng-template", 21);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 16)(7, "a", 17);
    i0.ɵɵpipe(8, "cxUrl");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelement(10, "cx-icon", 18);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 6, ctx_r2.deliveryMode$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r2.cartOutlets.DELIVERY_MODE)("cxOutletContext", i0.ɵɵpureFunction1(14, _c12, i0.ɵɵpipeBind1(5, 8, ctx_r2.cart$)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(8, 10, i0.ɵɵpureFunction1(16, _c9, ctx_r2.getCheckoutStepUrl(ctx_r2.checkoutStepTypeDeliveryMode))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(9, 12, "checkoutReview.editDeliveryMode"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.PENCIL);
  }
}
function CheckoutReviewSubmitComponent_ng_template_11_cx_card_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-card", 15);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const paymentDetails_r10 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(1, 1, ctx_r2.getPaymentMethodCard(paymentDetails_r10)));
  }
}
function CheckoutReviewSubmitComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "div");
    i0.ɵɵtemplate(2, CheckoutReviewSubmitComponent_ng_template_11_cx_card_2_Template, 2, 3, "cx-card", 20);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 16)(5, "a", 17);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelement(8, "cx-icon", 18);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx_r2.paymentDetails$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 6, i0.ɵɵpureFunction1(10, _c9, ctx_r2.getCheckoutStepUrl(ctx_r2.checkoutStepTypePaymentDetails))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(7, 8, "checkoutReview.editPaymentDetails"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.PENCIL);
  }
}
function CheckoutReviewSubmitComponent_ng_container_13_div_7_ng_template_2_Template(rf, ctx) {}
function CheckoutReviewSubmitComponent_ng_container_13_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "cx-promotions", 27);
    i0.ɵɵtemplate(2, CheckoutReviewSubmitComponent_ng_container_13_div_7_ng_template_2_Template, 0, 0, "ng-template", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entries_r11 = ctx.ngIf;
    const cart_r12 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("promotions", (cart_r12.appliedOrderPromotions || i0.ɵɵpureFunction0(3, _c13)).concat(cart_r12.potentialOrderPromotions || i0.ɵɵpureFunction0(4, _c13)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r2.cartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction2(5, _c14, entries_r11, ctx_r2.promotionLocation));
  }
}
function CheckoutReviewSubmitComponent_ng_container_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 24);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CheckoutReviewSubmitComponent_ng_container_13_div_7_Template, 3, 8, "div", 25);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r12 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(3, 4, "cartItems.cartTotal", i0.ɵɵpureFunction1(11, _c8, cart_r12.deliveryItemsQuantity)), ": ", cart_r12.totalPrice == null ? null : cart_r12.totalPrice.formattedValue, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 7, "checkoutReview.placeOrder"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 9, ctx_r2.entries$));
  }
}
function CheckoutReviewOverviewComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "cx-promotions", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r1 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(3, 3, "cartItems.cartTotal", i0.ɵɵpureFunction1(6, _c8, cart_r1.totalUnitCount)), ": ", cart_r1.totalPrice == null ? null : cart_r1.totalPrice.formattedValue, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("promotions", (cart_r1.appliedOrderPromotions || i0.ɵɵpureFunction0(8, _c13)).concat(cart_r1.potentialOrderPromotions || i0.ɵɵpureFunction0(9, _c13)));
  }
}
function CheckoutReviewPaymentComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div");
    i0.ɵɵelement(3, "cx-card", 3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4)(6, "a", 5);
    i0.ɵɵpipe(7, "cxUrl");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelement(9, "cx-icon", 6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "div", 2)(11, "div");
    i0.ɵɵelement(12, "cx-card", 3);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 4)(15, "a", 5);
    i0.ɵɵpipe(16, "cxUrl");
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelement(18, "cx-icon", 6);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const paymentDetails_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(4, 8, ctx_r1.getBillingAddressCard(paymentDetails_r1)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(7, 10, i0.ɵɵpureFunction1(20, _c9, ctx_r1.paymentDetailsStepRoute)));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(8, 12, "checkoutReview.editBillingDetails"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.PENCIL);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(13, 14, ctx_r1.getPaymentMethodCard(paymentDetails_r1)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(16, 16, i0.ɵɵpureFunction1(22, _c9, ctx_r1.paymentDetailsStepRoute)));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(17, 18, "checkoutReview.editPaymentDetails"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.PENCIL);
  }
}
function CheckoutReviewShippingComponent_ng_container_0_ng_container_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "cx-card", 12);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "div", 7)(4, "a", 8);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelement(7, "cx-icon", 9);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const deliveryAddress_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 4, ctx_r1.getDeliveryAddressCard(deliveryAddress_r1)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 6, i0.ɵɵpureFunction1(10, _c9, ctx_r1.deliveryAddressStepRoute)));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(6, 8, "checkoutReview.editDeliveryAddressDetails"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.PENCIL);
  }
}
function CheckoutReviewShippingComponent_ng_container_0_ng_container_1_cx_card_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-card", 12);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const deliveryMode_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(1, 1, ctx_r1.getDeliveryModeCard(deliveryMode_r3)));
  }
}
function CheckoutReviewShippingComponent_ng_container_0_ng_container_1_ng_template_18_Template(rf, ctx) {}
function CheckoutReviewShippingComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 1);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 2)(5, "div", 3);
    i0.ɵɵtemplate(6, CheckoutReviewShippingComponent_ng_container_0_ng_container_1_div_6_Template, 8, 12, "div", 4);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 3)(9, "div", 5);
    i0.ɵɵtemplate(10, CheckoutReviewShippingComponent_ng_container_0_ng_container_1_cx_card_10_Template, 2, 3, "cx-card", 6);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementStart(12, "div", 7)(13, "a", 8);
    i0.ɵɵpipe(14, "cxUrl");
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelement(16, "cx-icon", 9);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(17, "div", 10);
    i0.ɵɵtemplate(18, CheckoutReviewShippingComponent_ng_container_0_ng_container_1_ng_template_18_Template, 0, 0, "ng-template", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const entries_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 8, "checkoutMode.deliveryEntries"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 10, ctx_r1.deliveryAddress$));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 12, ctx_r1.deliveryMode$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(14, 14, i0.ɵɵpureFunction1(18, _c9, ctx_r1.deliveryModeStepRoute)));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(15, 16, "checkoutReview.editDeliveryMode"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.PENCIL);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r1.cartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction1(20, _c1, entries_r4));
  }
}
function CheckoutReviewShippingComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutReviewShippingComponent_ng_container_0_ng_container_1_Template, 19, 22, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const entries_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", entries_r4.length > 0);
  }
}
let CartNotEmptyGuard = /*#__PURE__*/(() => {
  class CartNotEmptyGuard {
    constructor(activeCartFacade, semanticPathService, router) {
      this.activeCartFacade = activeCartFacade;
      this.semanticPathService = semanticPathService;
      this.router = router;
    }
    canActivate() {
      return this.activeCartFacade.takeActive().pipe(map(cart => {
        if (this.isEmpty(cart)) {
          return this.router.parseUrl(this.semanticPathService.get('home') ?? '');
        }
        return true;
      }));
    }
    isEmpty(cart) {
      return cart && !cart.totalItems;
    }
    static {
      this.ɵfac = function CartNotEmptyGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CartNotEmptyGuard)(i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i1$1.SemanticPathService), i0.ɵɵinject(i3.Router));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CartNotEmptyGuard,
        factory: CartNotEmptyGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CartNotEmptyGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutFlowOrchestratorService = /*#__PURE__*/(() => {
  class CheckoutFlowOrchestratorService {
    constructor() {
      this.checkoutConfig = inject(CheckoutConfig);
      this.baseSiteService = inject(BaseSiteService);
      this.paymentProviderName = undefined;
      this.getPaymentProvider().subscribe(paymentProvider => {
        this.paymentProviderName = paymentProvider;
      });
    }
    getPaymentProvider() {
      return this.baseSiteService.get().pipe(take(1), map(baseSite => baseSite?.baseStore?.paymentProvider));
    }
    getCheckoutFlow() {
      if (this.paymentProviderName) {
        const flow = this.checkoutConfig.checkout?.flows?.[this.paymentProviderName];
        if (flow) {
          return flow;
        }
      }
      return this.checkoutConfig.checkout;
    }
    static {
      this.ɵfac = function CheckoutFlowOrchestratorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutFlowOrchestratorService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutFlowOrchestratorService,
        factory: CheckoutFlowOrchestratorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutFlowOrchestratorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutConfigService = /*#__PURE__*/(() => {
  class CheckoutConfigService {
    constructor(checkoutConfig) {
      this.checkoutConfig = checkoutConfig;
      this.checkoutFlowOrchestratorService = inject(CheckoutFlowOrchestratorService);
      this.express = this.checkoutConfig.checkout?.express ?? false;
      this.guest = this.checkoutConfig.checkout?.guest ?? false;
      this.defaultDeliveryMode = this.checkoutConfig.checkout?.defaultDeliveryMode || [];
      this.checkoutFlow = this.checkoutFlowOrchestratorService?.getCheckoutFlow();
      if (this.checkoutFlowOrchestratorService) {
        this.express = this.checkoutFlow?.express ?? false;
        this.guest = this.checkoutFlow?.guest ?? false;
        this.defaultDeliveryMode = this.checkoutFlow?.defaultDeliveryMode || [];
      }
    }
    compareDeliveryCost(deliveryMode1, deliveryMode2) {
      if (deliveryMode1.deliveryCost?.value && deliveryMode2.deliveryCost?.value) {
        if (deliveryMode1.deliveryCost.value > deliveryMode2.deliveryCost.value) {
          return 1;
        } else if (deliveryMode1.deliveryCost.value < deliveryMode2.deliveryCost.value) {
          return -1;
        }
      }
      return 0;
    }
    findMatchingDeliveryMode(deliveryModes, index = 0) {
      switch (this.defaultDeliveryMode[index]) {
        case DeliveryModePreferences.FREE:
          if (deliveryModes[0].deliveryCost?.value === 0) {
            return deliveryModes[0].code;
          }
          break;
        case DeliveryModePreferences.LEAST_EXPENSIVE:
          const leastExpensiveFound = deliveryModes.find(deliveryMode => deliveryMode.deliveryCost?.value !== 0);
          if (leastExpensiveFound) {
            return leastExpensiveFound.code;
          }
          break;
        case DeliveryModePreferences.MOST_EXPENSIVE:
          return deliveryModes[deliveryModes.length - 1].code;
        default:
          const codeFound = deliveryModes.find(deliveryMode => deliveryMode.code === this.defaultDeliveryMode[index]);
          if (codeFound) {
            return codeFound.code;
          }
      }
      const lastMode = this.defaultDeliveryMode.length - 1 <= index;
      return lastMode ? deliveryModes[0].code : this.findMatchingDeliveryMode(deliveryModes, index + 1);
    }
    shouldUseAddressSavedInCart() {
      if (this.checkoutFlowOrchestratorService) {
        return !!this.checkoutFlow?.guestUseSavedAddress;
      }
      return !!this.checkoutConfig?.checkout?.guestUseSavedAddress;
    }
    getPreferredDeliveryMode(deliveryModes) {
      deliveryModes.sort(this.compareDeliveryCost);
      return this.findMatchingDeliveryMode(deliveryModes);
    }
    isExpressCheckout() {
      return this.express;
    }
    isGuestCheckout() {
      return this.guest;
    }
    static {
      this.ɵfac = function CheckoutConfigService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutConfigService)(i0.ɵɵinject(i2.CheckoutConfig));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutConfigService,
        factory: CheckoutConfigService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutConfigService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutAuthGuard = /*#__PURE__*/(() => {
  class CheckoutAuthGuard {
    constructor(authService, authRedirectService, checkoutConfigService, activeCartFacade, semanticPathService, router) {
      this.authService = authService;
      this.authRedirectService = authRedirectService;
      this.checkoutConfigService = checkoutConfigService;
      this.activeCartFacade = activeCartFacade;
      this.semanticPathService = semanticPathService;
      this.router = router;
    }
    canActivate() {
      return combineLatest([this.authService.isUserLoggedIn(), this.activeCartFacade.isGuestCart(), this.activeCartFacade.isStable()]).pipe(map(([isLoggedIn, isGuestCart, isStable]) => ({
        isLoggedIn,
        isGuestCart,
        isStable
      })), filter(data => data.isStable), map(data => {
        if (!data.isLoggedIn) {
          return data.isGuestCart ? true : this.handleAnonymousUser();
        }
        return data.isLoggedIn;
      }));
    }
    handleAnonymousUser() {
      this.authRedirectService.saveCurrentNavigationUrl();
      if (this.checkoutConfigService.isGuestCheckout()) {
        return this.router.createUrlTree([this.semanticPathService.get('login')], {
          queryParams: {
            forced: true
          }
        });
      } else {
        return this.router.parseUrl(this.semanticPathService.get('login') ?? '');
      }
    }
    static {
      this.ɵfac = function CheckoutAuthGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutAuthGuard)(i0.ɵɵinject(i1$1.AuthService), i0.ɵɵinject(i1$1.AuthRedirectService), i0.ɵɵinject(CheckoutConfigService), i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i1$1.SemanticPathService), i0.ɵɵinject(i3.Router));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutAuthGuard,
        factory: CheckoutAuthGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutAuthGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutStepService = /*#__PURE__*/(() => {
  class CheckoutStepService {
    constructor(routingService, checkoutConfig, routingConfigService) {
      this.routingService = routingService;
      this.checkoutConfig = checkoutConfig;
      this.routingConfigService = routingConfigService;
      this.checkoutFlowOrchestratorService = inject(CheckoutFlowOrchestratorService);
      this.steps$ = new BehaviorSubject([]);
      this.activeStepIndex$ = this.routingService.getRouterState().pipe(switchMap(router => {
        const activeStepUrl = router.state.context.id;
        return this.steps$.pipe(map(steps => {
          let activeIndex = 0;
          steps.forEach((step, index) => {
            const routeUrl = `/${this.routingConfigService.getRouteConfig(step?.routeName)?.paths?.[0]}`;
            if (routeUrl === activeStepUrl) {
              activeIndex = index;
            }
          });
          return activeIndex;
        }));
      }));
      this.resetSteps();
    }
    back(activatedRoute) {
      const previousUrl = this.getPreviousCheckoutStepUrl(activatedRoute);
      this.routingService.go(previousUrl === null ? 'cart' : previousUrl);
    }
    next(activatedRoute) {
      const nextUrl = this.getNextCheckoutStepUrl(activatedRoute);
      this.routingService.go(nextUrl);
    }
    goToStepWithIndex(stepIndex) {
      this.routingService.go(this.getStepUrlFromStepRoute(this.allSteps[stepIndex].routeName));
    }
    getBackBntText(activatedRoute) {
      if (this.getPreviousCheckoutStepUrl(activatedRoute) === null) {
        return 'checkout.backToCart';
      }
      return 'common.back';
    }
    resetSteps() {
      let steps = this.checkoutConfig.checkout?.steps ?? [];
      if (this.checkoutFlowOrchestratorService) {
        steps = this.checkoutFlowOrchestratorService.getCheckoutFlow()?.steps ?? [];
      }
      this.allSteps = steps.filter(step => !step.disabled).map(checkoutStep => Object.assign({}, checkoutStep));
      this.steps$.next(this.allSteps);
    }
    disableEnableStep(currentStepType, disabled) {
      const currentStep = this.allSteps.find(step => step.type.includes(currentStepType));
      if (currentStep && currentStep.disabled !== disabled) {
        currentStep.disabled = disabled;
        this.steps$.next(this.allSteps.filter(step => !step.disabled));
      }
    }
    getCheckoutStep(currentStepType) {
      const index = this.getCheckoutStepIndex('type', currentStepType);
      if (index !== null) {
        return this.allSteps[index];
      }
    }
    getCheckoutStepRoute(currentStepType) {
      return this.getCheckoutStep(currentStepType)?.routeName;
    }
    getFirstCheckoutStepRoute() {
      return this.allSteps[0].routeName;
    }
    getNextCheckoutStepUrl(activatedRoute) {
      const stepIndex = this.getCurrentStepIndex(activatedRoute);
      if (stepIndex !== null && stepIndex >= 0) {
        let i = 1;
        while (this.allSteps[stepIndex + i] && this.allSteps[stepIndex + i].disabled) {
          i++;
        }
        const nextStep = this.allSteps[stepIndex + i];
        if (nextStep) {
          return this.getStepUrlFromStepRoute(nextStep.routeName);
        }
      }
      return null;
    }
    getPreviousCheckoutStepUrl(activatedRoute) {
      const stepIndex = this.getCurrentStepIndex(activatedRoute);
      if (stepIndex !== null && stepIndex >= 0) {
        let i = 1;
        while (this.allSteps[stepIndex - i] && this.allSteps[stepIndex - i].disabled) {
          i++;
        }
        const previousStep = this.allSteps[stepIndex - i];
        if (previousStep) {
          return this.getStepUrlFromStepRoute(previousStep.routeName);
        }
      }
      return null;
    }
    getCurrentStepIndex(activatedRoute) {
      const currentStepUrl = this.getStepUrlFromActivatedRoute(activatedRoute);
      const stepIndex = this.allSteps.findIndex(step => currentStepUrl === `/${this.getStepUrlFromStepRoute(step.routeName)}`);
      return stepIndex === -1 ? null : stepIndex;
    }
    getStepUrlFromActivatedRoute(activatedRoute) {
      return activatedRoute && activatedRoute.snapshot && activatedRoute.snapshot.url ? `/${activatedRoute.snapshot.url.join('/')}` : null;
    }
    getStepUrlFromStepRoute(stepRoute) {
      return this.routingConfigService.getRouteConfig(stepRoute)?.paths?.[0] ?? null;
    }
    getCheckoutStepIndex(key, value) {
      return key && value ? this.allSteps.findIndex(step => {
        const propertyVal = step[key];
        return propertyVal instanceof Array ? propertyVal.includes(value) : propertyVal === value;
      }) : null;
    }
    static {
      this.ɵfac = function CheckoutStepService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutStepService)(i0.ɵɵinject(i1$1.RoutingService), i0.ɵɵinject(i2.CheckoutConfig), i0.ɵɵinject(i1$1.RoutingConfigService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutStepService,
        factory: CheckoutStepService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutStepService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let ExpressCheckoutService = /*#__PURE__*/(() => {
  class ExpressCheckoutService {
    constructor(userAddressService, userPaymentService, checkoutDeliveryAddressFacade, checkoutPaymentFacade, checkoutConfigService, checkoutDeliveryModesFacade) {
      this.userAddressService = userAddressService;
      this.userPaymentService = userPaymentService;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.checkoutConfigService = checkoutConfigService;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.setDeliveryAddress();
      this.setDeliveryMode();
      this.setPaymentMethod();
    }
    setDeliveryAddress() {
      this.deliveryAddressSet$ = combineLatest([this.userAddressService.getAddresses(), this.userAddressService.getAddressesLoadedSuccess()]).pipe(debounceTime(0), tap(([, addressesLoadedSuccess]) => {
        if (!addressesLoadedSuccess) {
          this.userAddressService.loadAddresses();
        }
      }), filter(([, addressesLoadedSuccess]) => addressesLoadedSuccess), take(1), switchMap(([addresses]) => {
        const defaultAddress = addresses.find(address => address.defaultAddress) || addresses[0];
        if (defaultAddress && Object.keys(defaultAddress).length) {
          return this.checkoutDeliveryAddressFacade.setDeliveryAddress(defaultAddress).pipe(switchMap(() => this.checkoutDeliveryAddressFacade.getDeliveryAddressState()), filter(state => !state.error && !state.loading), map(state => state.data), map(data => !!(data && Object.keys(data).length)), catchError(() => of(false)));
        }
        return of(false);
      }), distinctUntilChanged());
    }
    setDeliveryMode() {
      this.deliveryModeSet$ = combineLatest([this.deliveryAddressSet$, this.checkoutDeliveryModesFacade.getSupportedDeliveryModesState()]).pipe(debounceTime(0), switchMap(([addressSet, supportedDeliveryModesState]) => {
        if (!addressSet) {
          return of(false);
        }
        return of([supportedDeliveryModesState]).pipe(filter(([supportedDeliveryModesStateObject]) => !supportedDeliveryModesStateObject.loading && !!supportedDeliveryModesStateObject.data?.length), switchMap(([deliveryModesState]) => {
          if (!deliveryModesState.data) {
            return of(false);
          }
          const preferredDeliveryMode = this.checkoutConfigService.getPreferredDeliveryMode(deliveryModesState.data);
          return of([preferredDeliveryMode]).pipe(switchMap(([deliveryMode]) => {
            if (!deliveryMode) {
              return of(false);
            }
            return this.checkoutDeliveryModesFacade.setDeliveryMode(deliveryMode).pipe(switchMap(() => this.checkoutDeliveryModesFacade.getSelectedDeliveryModeState()), filter(state => !state.error && !state.loading), map(state => state.data), map(data => !!(data && Object.keys(data).length)), catchError(() => of(false)));
          }));
        }));
      }), distinctUntilChanged());
    }
    setPaymentMethod() {
      this.paymentMethodSet$ = combineLatest([this.deliveryModeSet$, this.userPaymentService.getPaymentMethods(), this.userPaymentService.getPaymentMethodsLoadedSuccess()]).pipe(debounceTime(0), tap(([,, paymentMethodsLoadedSuccess]) => {
        if (!paymentMethodsLoadedSuccess) {
          this.userPaymentService.loadPaymentMethods();
        }
      }), filter(([,, success]) => success), switchMap(([deliveryModeSet, payments]) => {
        if (!deliveryModeSet) {
          return of(false);
        }
        const defaultPayment = payments.find(address => address.defaultPayment) || payments[0];
        if (!defaultPayment || Object.keys(defaultPayment).length === 0) {
          return of(false);
        }
        return this.checkoutPaymentFacade.setPaymentDetails(defaultPayment).pipe(switchMap(() => this.checkoutPaymentFacade.getPaymentDetailsState()), filter(state => !state.error && !state.loading), map(state => state.data), map(data => !!(data && Object.keys(data).length)), catchError(() => of(false)));
      }), distinctUntilChanged());
    }
    trySetDefaultCheckoutDetails() {
      return this.paymentMethodSet$.pipe(map(paymentMethodSet => !!paymentMethodSet));
    }
    static {
      this.ɵfac = function ExpressCheckoutService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ExpressCheckoutService)(i0.ɵɵinject(i1$1.UserAddressService), i0.ɵɵinject(i1$1.UserPaymentService), i0.ɵɵinject(i2.CheckoutDeliveryAddressFacade), i0.ɵɵinject(i2.CheckoutPaymentFacade), i0.ɵɵinject(CheckoutConfigService), i0.ɵɵinject(i2.CheckoutDeliveryModesFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ExpressCheckoutService,
        factory: ExpressCheckoutService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ExpressCheckoutService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutDeliveryAddressComponent = /*#__PURE__*/(() => {
  class CheckoutDeliveryAddressComponent {
    get isGuestCheckout() {
      return !!getLastValueSync(this.activeCartFacade.isGuestCart());
    }
    get backBtnText() {
      return this.checkoutStepService.getBackBntText(this.activatedRoute);
    }
    get selectedAddress$() {
      return this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(filter(state => !state.loading), map(state => state.data), distinctUntilChanged((prev, curr) => prev?.id === curr?.id));
    }
    constructor(userAddressService, checkoutDeliveryAddressFacade, activatedRoute, translationService, activeCartFacade, checkoutStepService, checkoutDeliveryModesFacade, globalMessageService) {
      this.userAddressService = userAddressService;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.activatedRoute = activatedRoute;
      this.translationService = translationService;
      this.activeCartFacade = activeCartFacade;
      this.checkoutStepService = checkoutStepService;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.globalMessageService = globalMessageService;
      this.checkoutConfigService = inject(CheckoutConfigService);
      this.featureConfigService = inject(FeatureConfigService, {
        optional: true
      });
      this.busy$ = new BehaviorSubject(false);
      this.addressFormOpened = false;
      this.doneAutoSelect = false;
      this.focusService = inject(SelectFocusUtility);
      this.windowRef = inject(WindowRef);
    }
    ngOnInit() {
      this.loadAddresses();
      this.cards$ = this.createCards();
      this.isUpdating$ = this.createIsUpdating();
    }
    getCardContent(address, selected, textDefaultDeliveryAddress, textShipToThisAddress, textSelected, textPhone, textMobile) {
      // TODO: (CXSPA-6956) - Remove feature flag in next major release
      const hideSelectActionForSelected = this.featureConfigService?.isEnabled('a11yHideSelectBtnForSelectedAddrOrPayment');
      let region = '';
      if (address.region && address.region.isocode) {
        region = address.region.isocode + ', ';
      }
      const numbers = getAddressNumbers(address, textPhone, textMobile);
      const isSelected = selected && selected.id === address.id;
      const role = this.getCardRole(isSelected);
      return {
        role,
        title: address.defaultAddress ? textDefaultDeliveryAddress : '',
        textBold: address.firstName + ' ' + address.lastName,
        text: [address.line1, address.line2, address.town + ', ' + region + address.country?.isocode, address.postalCode, numbers],
        actions: hideSelectActionForSelected && isSelected ? [] : [{
          name: textShipToThisAddress,
          event: 'send'
        }],
        header: isSelected ? textSelected : '',
        label: address.defaultAddress ? 'addressBook.defaultDeliveryAddress' : 'addressBook.additionalDeliveryAddress'
      };
    }
    selectAddress(address) {
      if (address?.id === getLastValueSync(this.selectedAddress$)?.id) {
        return;
      }
      this.globalMessageService.add({
        key: 'checkoutAddress.deliveryAddressSelected'
      }, GlobalMessageType.MSG_TYPE_INFO);
      this.setAddress(address);
      if (this.featureConfigService?.isEnabled('a11yFocusOnCardAfterSelecting')) {
        this.focusCardAfterSelecting();
      }
    }
    /**
     * Restores the focus to the Card component after it has been selected and the checkout has finished updating.
     * The focus is lost due to DOM changes making it otherwise impossible to target elements that have been removed.
     */
    focusCardAfterSelecting() {
      const cardNodes = Array.from(this.windowRef?.document.querySelectorAll('cx-card'));
      const triggeredCard = this.windowRef?.document.activeElement?.closest('cx-card');
      if (triggeredCard) {
        const selectedCardIndex = cardNodes.indexOf(triggeredCard);
        this.isUpdating$.pipe(filter(isUpdating => !isUpdating), take(1)).subscribe(() => {
          requestAnimationFrame(() => {
            const selectedCard = this.windowRef?.document.querySelectorAll('cx-card')[selectedCardIndex];
            this.focusService.findFirstFocusable(selectedCard)?.focus();
          });
        });
      }
    }
    addAddress(address) {
      if (!address && this.shouldUseAddressSavedInCart() && this.selectedAddress) {
        this.next();
      }
      if (!address) {
        return;
      }
      this.busy$.next(true);
      this.doneAutoSelect = true;
      this.checkoutDeliveryAddressFacade.createAndSetAddress(address).pipe(switchMap(() => this.checkoutDeliveryModesFacade.clearCheckoutDeliveryMode())).subscribe({
        complete: () => {
          // we don't call onSuccess here, because it can cause a spinner flickering
          this.next();
        },
        error: () => {
          this.onError();
          this.doneAutoSelect = false;
        }
      });
    }
    showNewAddressForm() {
      this.addressFormOpened = true;
    }
    hideNewAddressForm(goPrevious = false) {
      this.addressFormOpened = false;
      if (goPrevious) {
        this.back();
      }
    }
    next() {
      this.checkoutStepService.next(this.activatedRoute);
    }
    back() {
      this.checkoutStepService.back(this.activatedRoute);
    }
    loadAddresses() {
      if (!this.isGuestCheckout) {
        this.userAddressService.loadAddresses();
      }
    }
    createCards() {
      const addresses$ = combineLatest([this.getSupportedAddresses(), this.selectedAddress$]);
      const translations$ = combineLatest([this.translationService.translate('checkoutAddress.defaultDeliveryAddress'), this.translationService.translate('checkoutAddress.shipToThisAddress'), this.featureConfigService?.isEnabled('a11ySelectLabelWithContextForSelectedAddrOrPayment') ? this.translationService.translate('addressCard.selectedAddress') : this.translationService.translate('addressCard.selected'), this.translationService.translate('addressCard.phoneNumber'), this.translationService.translate('addressCard.mobileNumber')]);
      return combineLatest([addresses$, translations$]).pipe(tap(([[addresses, selected]]) => this.selectDefaultAddress(addresses, selected)), map(([[addresses, selected], [textDefault, textShipTo, textSelected, textPhone, textMobile]]) => addresses?.map(address => ({
        address,
        card: this.getCardContent(address, selected, textDefault, textShipTo, textSelected, textPhone, textMobile)
      }))));
    }
    selectDefaultAddress(addresses, selected) {
      if (!this.doneAutoSelect && addresses?.length && (!selected || Object.keys(selected).length === 0)) {
        selected = addresses.find(address => address.defaultAddress);
        if (selected) {
          this.setAddress(selected);
        }
        this.doneAutoSelect = true;
      } else if (selected && this.shouldUseAddressSavedInCart()) {
        this.selectedAddress = selected;
      }
    }
    getSupportedAddresses() {
      return this.userAddressService.getAddresses();
    }
    createIsUpdating() {
      return combineLatest([this.busy$, this.userAddressService.getAddressesLoading(), this.getAddressLoading()]).pipe(map(([busy, userAddressLoading, deliveryAddressLoading]) => busy || userAddressLoading || deliveryAddressLoading), distinctUntilChanged());
    }
    getAddressLoading() {
      return this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(map(state => state.loading), distinctUntilChanged());
    }
    setAddress(address) {
      this.busy$.next(true);
      this.checkoutDeliveryAddressFacade.setDeliveryAddress(address).pipe(switchMap(() => this.checkoutDeliveryModesFacade.clearCheckoutDeliveryMode())).subscribe({
        complete: () => {
          this.onSuccess();
        },
        error: () => {
          this.onError();
        }
      });
    }
    onSuccess() {
      this.busy$.next(false);
    }
    onError() {
      this.busy$.next(false);
    }
    shouldUseAddressSavedInCart() {
      return !!this.checkoutConfigService?.shouldUseAddressSavedInCart();
    }
    getCardRole(isCardSelected) {
      const isButtonRole = this.featureConfigService?.isEnabled('a11ySelectLabelWithContextForSelectedAddrOrPayment') && !isCardSelected;
      return isButtonRole ? 'button' : 'application';
    }
    static {
      this.ɵfac = function CheckoutDeliveryAddressComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutDeliveryAddressComponent)(i0.ɵɵdirectiveInject(i1$1.UserAddressService), i0.ɵɵdirectiveInject(i2.CheckoutDeliveryAddressFacade), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i1$1.TranslationService), i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(CheckoutStepService), i0.ɵɵdirectiveInject(i2.CheckoutDeliveryModesFacade), i0.ɵɵdirectiveInject(i1$1.GlobalMessageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutDeliveryAddressComponent,
        selectors: [["cx-delivery-address"]],
        standalone: false,
        decls: 5,
        vars: 2,
        consts: [["content", ""], ["loading", ""], ["showExistingAddresses", ""], ["newAddressForm", ""], ["initialAddressForm", ""], [4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet"], [1, "cx-checkout-title", "d-none", "d-lg-block", "d-xl-block"], [4, "ngIf"], ["role", "status", 4, "cxFeature"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["role", "status"], [1, "cx-checkout-text"], [1, "cx-checkout-btns", "cx-checkout-btns-top"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "cx-checkout-body", "row"], ["class", "cx-delivery-address-card col-md-12 col-lg-6", 4, "ngFor", "ngForOf"], [1, "cx-checkout-btns", "cx-checkout-btns-bottom"], [1, "cx-checkout-btns", "row"], [1, "col-md-12", "col-lg-6"], [1, "cx-btn", "btn", "btn-block", "btn-secondary", 3, "click"], [1, "cx-btn", "btn", "btn-block", "btn-primary", 3, "click", "disabled"], [1, "cx-delivery-address-card", "col-md-12", "col-lg-6"], [1, "cx-delivery-address-card-inner", 3, "click"], [3, "sendCard", "border", "index", "fitToContainer", "content", "role"], [3, "showTitleCode", "backToAddress", "submitAddress", 4, "ngIf", "ngIfElse"], [3, "backToAddress", "submitAddress", "showTitleCode"], [3, "backToAddress", "submitAddress", "showTitleCode", "setAsDefaultField", "addressData", "cancelBtnLabel"], [1, "cx-spinner"]],
        template: function CheckoutDeliveryAddressComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutDeliveryAddressComponent_section_0_Template, 3, 4, "section", 5)(1, CheckoutDeliveryAddressComponent_ng_template_1_Template, 5, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, CheckoutDeliveryAddressComponent_ng_template_3_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const content_r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.featureConfigService == null ? null : ctx.featureConfigService.isEnabled("a11yCheckoutStepsLandmarks"))("ngIfElse", content_r1);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, i7.AddressFormComponent, i4.CardComponent, i4.SpinnerComponent, i1$1.FeatureDirective, i2$1.AsyncPipe, i1$1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutDeliveryAddressComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutDeliveryAddressModule = /*#__PURE__*/(() => {
  class CheckoutDeliveryAddressModule {
    static {
      this.ɵfac = function CheckoutDeliveryAddressModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutDeliveryAddressModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutDeliveryAddressModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutDeliveryAddress: {
              component: CheckoutDeliveryAddressComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard, CartValidationGuard]
            }
          }
        })],
        imports: [CommonModule, RouterModule, AddressFormModule, CardModule, SpinnerModule, I18nModule, FeaturesConfigModule]
      });
    }
  }
  return CheckoutDeliveryAddressModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutDeliveryModeComponent = /*#__PURE__*/(() => {
  class CheckoutDeliveryModeComponent {
    get deliveryModeInvalid() {
      return this.mode.controls['deliveryModeId'].invalid;
    }
    constructor(fb, checkoutConfigService, activatedRoute, checkoutStepService, checkoutDeliveryModesFacade, activeCartFacade) {
      this.fb = fb;
      this.checkoutConfigService = checkoutConfigService;
      this.activatedRoute = activatedRoute;
      this.checkoutStepService = checkoutStepService;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.activeCartFacade = activeCartFacade;
      this.globalMessageService = inject(GlobalMessageService);
      this.busy$ = new BehaviorSubject(false);
      this.isSetDeliveryModeHttpErrorSub = new BehaviorSubject(false);
      this.CartOutlets = CartOutlets;
      this.isSetDeliveryModeHttpError$ = this.isSetDeliveryModeHttpErrorSub.asObservable();
      this.selectedDeliveryModeCode$ = this.checkoutDeliveryModesFacade.getSelectedDeliveryModeState().pipe(filter(state => !state.loading), map(state => state.data), map(deliveryMode => deliveryMode?.code));
      this.supportedDeliveryModes$ = this.checkoutDeliveryModesFacade.getSupportedDeliveryModes().pipe(filter(deliveryModes => !!deliveryModes?.length), withLatestFrom(this.selectedDeliveryModeCode$), tap(([deliveryModes, code]) => {
        if (!code || !deliveryModes.find(deliveryMode => deliveryMode.code === code)) {
          code = this.checkoutConfigService.getPreferredDeliveryMode(deliveryModes);
        }
        if (code) {
          this.mode.controls['deliveryModeId'].setValue(code);
          this.changeMode(code);
        }
      }), map(([deliveryModes]) => deliveryModes.filter(mode => mode.code !== 'pickup')));
      this.backBtnText = this.checkoutStepService.getBackBntText(this.activatedRoute);
      this.mode = this.fb.group({
        deliveryModeId: ['', Validators.required]
      });
      this.isUpdating$ = combineLatest([this.busy$, this.checkoutDeliveryModesFacade.getSelectedDeliveryModeState().pipe(map(state => state.loading))]).pipe(map(([busy, loading]) => busy || loading), distinctUntilChanged());
    }
    changeMode(code, event) {
      if (!code) {
        return;
      }
      const lastFocusedId = event?.target?.id;
      this.busy$.next(true);
      this.checkoutDeliveryModesFacade.setDeliveryMode(code).subscribe({
        complete: () => this.onSuccess(),
        error: () => this.onError()
      });
      const isTriggeredByKeyboard = event?.screenX === 0;
      if (isTriggeredByKeyboard) {
        this.restoreFocus(lastFocusedId, code);
        return;
      }
      this.mode.setValue({
        deliveryModeId: code
      });
    }
    next() {
      this.checkoutStepService.next(this.activatedRoute);
    }
    back() {
      this.checkoutStepService.back(this.activatedRoute);
    }
    getAriaChecked(code) {
      return code === this.mode.controls['deliveryModeId'].value;
    }
    onSuccess() {
      this.isSetDeliveryModeHttpErrorSub.next(false);
      this.busy$.next(false);
    }
    onError() {
      this.globalMessageService?.add({
        key: 'setDeliveryMode.unknownError'
      }, GlobalMessageType.MSG_TYPE_ERROR);
      this.isSetDeliveryModeHttpErrorSub.next(true);
      this.busy$.next(false);
    }
    /**
     * Restores focus after data is updated.
     */
    restoreFocus(lastFocusedId, code) {
      this.isUpdating$.pipe(filter(isUpdating => !isUpdating), take(1)).subscribe(() => {
        setTimeout(() => {
          document.querySelector('main')?.classList.remove('mouse-focus');
          this.mode.setValue({
            deliveryModeId: code
          });
          document.getElementById(lastFocusedId)?.focus();
        }, 0);
      });
    }
    static {
      this.ɵfac = function CheckoutDeliveryModeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutDeliveryModeComponent)(i0.ɵɵdirectiveInject(i3$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(CheckoutConfigService), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(CheckoutStepService), i0.ɵɵdirectiveInject(i2.CheckoutDeliveryModesFacade), i0.ɵɵdirectiveInject(i1.ActiveCartFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutDeliveryModeComponent,
        selectors: [["cx-delivery-mode"]],
        standalone: false,
        decls: 19,
        vars: 17,
        consts: [["loading", ""], ["role", "radiogroup", 4, "cxFeature"], [4, "cxFeature"], [4, "ngIf"], ["cxInnerComponentsHost", ""], [1, "row", "cx-checkout-btns"], [1, "col-md-12", "col-lg-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "btn", "btn-block", "btn-primary", 3, "click", "disabled"], ["role", "radiogroup"], [4, "ngIf", "ngIfElse"], [1, "cx-checkout-title", "d-none", "d-lg-block", "d-xl-block"], ["role", "status", 4, "cxFeature"], [1, "cx-delivery-mode-wrapper", 3, "formGroup"], ["class", "form-check", 4, "ngFor", "ngForOf"], [3, "cxOutlet", "cxOutletContext"], ["role", "status"], [1, "form-check"], ["type", "radio", "formControlName", "deliveryModeId", 1, "form-check-input", 3, "change", "click", "value", "id"], ["aria-hidden", "true", 1, "cx-delivery-label", "form-check-label", "form-radio-label", 3, "for"], [1, "cx-delivery-mode"], [1, "cx-delivery-mode-description"], [1, "cx-delivery-price"], [1, "cx-delivery-details"], ["role", "radio", "type", "radio", "formControlName", "deliveryModeId", 1, "form-check-input", 3, "change", "click", "id", "value"], [1, "cx-delivery-label", "form-check-label", "form-radio-label", 3, "for"], [1, "cx-spinner"]],
        template: function CheckoutDeliveryModeComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "section");
            i0.ɵɵpipe(1, "cxTranslate");
            i0.ɵɵtemplate(2, CheckoutDeliveryModeComponent_fieldset_2_Template, 6, 8, "fieldset", 1)(3, CheckoutDeliveryModeComponent_ng_container_3_Template, 7, 9, "ng-container", 2)(4, CheckoutDeliveryModeComponent_ng_container_4_Template, 6, 9, "ng-container", 3);
            i0.ɵɵpipe(5, "async");
            i0.ɵɵtemplate(6, CheckoutDeliveryModeComponent_ng_template_6_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementContainer(8, 4);
            i0.ɵɵelementStart(9, "div", 5)(10, "div", 6)(11, "button", 7);
            i0.ɵɵlistener("click", function CheckoutDeliveryModeComponent_Template_button_click_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.back());
            });
            i0.ɵɵtext(12);
            i0.ɵɵpipe(13, "cxTranslate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 6)(15, "button", 8);
            i0.ɵɵpipe(16, "async");
            i0.ɵɵlistener("click", function CheckoutDeliveryModeComponent_Template_button_click_15_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.next());
            });
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "cxTranslate");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 7, "checkoutProgress.deliveryMode"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "a11yDeliveryModeRadiogroup");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!a11yDeliveryModeRadiogroup");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 9, ctx.activeCartFacade.hasPickupItems()));
            i0.ɵɵadvance(8);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 11, ctx.backBtnText), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", ctx.deliveryModeInvalid || i0.ɵɵpipeBind1(16, 13, ctx.isSetDeliveryModeHttpError$));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 15, "common.continue"), " ");
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i3$1.DefaultValueAccessor, i3$1.RadioControlValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.FormGroupDirective, i3$1.FormControlName, i4.SpinnerComponent, i4.OutletDirective, i4.InnerComponentsHostDirective, i1$1.FeatureDirective, i2$1.AsyncPipe, i1$1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutDeliveryModeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutDeliveryModeModule = /*#__PURE__*/(() => {
  class CheckoutDeliveryModeModule {
    static {
      this.ɵfac = function CheckoutDeliveryModeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutDeliveryModeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutDeliveryModeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutDeliveryMode: {
              component: CheckoutDeliveryModeComponent,
              data: {
                composition: {
                  inner: ['PickupInStoreDeliveryModeComponent']
                }
              },
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [CommonModule, ReactiveFormsModule, I18nModule, SpinnerModule, OutletModule, PageComponentModule, FeaturesConfigModule]
      });
    }
  }
  return CheckoutDeliveryModeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let NotCheckoutAuthGuard = /*#__PURE__*/(() => {
  class NotCheckoutAuthGuard {
    constructor(authService, activeCartFacade, semanticPathService, router) {
      this.authService = authService;
      this.activeCartFacade = activeCartFacade;
      this.semanticPathService = semanticPathService;
      this.router = router;
    }
    canActivate() {
      return this.authService.isUserLoggedIn().pipe(map(isLoggedIn => {
        if (isLoggedIn) {
          return this.router.parseUrl(this.semanticPathService.get('home') ?? '');
        } else if (!!getLastValueSync(this.activeCartFacade.isGuestCart())) {
          return this.router.parseUrl(this.semanticPathService.get('cart') ?? '');
        }
        return !isLoggedIn;
      }));
    }
    static {
      this.ɵfac = function NotCheckoutAuthGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotCheckoutAuthGuard)(i0.ɵɵinject(i1$1.AuthService), i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(i1$1.SemanticPathService), i0.ɵɵinject(i3.Router));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NotCheckoutAuthGuard,
        factory: NotCheckoutAuthGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NotCheckoutAuthGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutLoginComponent = /*#__PURE__*/(() => {
  class CheckoutLoginComponent {
    constructor(formBuilder, authRedirectService, activeCartFacade) {
      this.formBuilder = formBuilder;
      this.authRedirectService = authRedirectService;
      this.activeCartFacade = activeCartFacade;
      this.checkoutLoginForm = this.formBuilder.group({
        email: ['', [Validators.required, CustomFormValidators.emailValidator]],
        emailConfirmation: ['', [Validators.required]]
      }, {
        validators: CustomFormValidators.emailsMustMatch('email', 'emailConfirmation')
      });
    }
    onSubmit() {
      if (this.checkoutLoginForm.valid) {
        const email = this.checkoutLoginForm.get('email')?.value;
        this.activeCartFacade.addEmail(email);
        if (!this.sub) {
          this.sub = this.activeCartFacade.isGuestCart().subscribe(isGuest => {
            if (isGuest) {
              this.authRedirectService.redirect();
            }
          });
        }
      } else {
        this.checkoutLoginForm.markAllAsTouched();
      }
    }
    ngOnDestroy() {
      if (this.sub) {
        this.sub.unsubscribe();
      }
    }
    static {
      this.ɵfac = function CheckoutLoginComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutLoginComponent)(i0.ɵɵdirectiveInject(i3$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$1.AuthRedirectService), i0.ɵɵdirectiveInject(i1.ActiveCartFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutLoginComponent,
        selectors: [["cx-checkout-login"]],
        standalone: false,
        decls: 25,
        vars: 24,
        consts: [[3, "ngSubmit", "formGroup"], [1, "form-group"], [1, "label-content"], ["required", "true", "type", "email", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], ["id", "emailError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "email", "name", "emailConfirmation", "formControlName", "emailConfirmation", 1, "form-control", 3, "placeholder"], ["id", "emailConfirmationError", 3, "translationParams", "control", 4, "cxFeature"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"], ["id", "emailError", 3, "translationParams", "control"], [3, "control"], ["id", "emailConfirmationError", 3, "translationParams", "control"]],
        template: function CheckoutLoginComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵlistener("ngSubmit", function CheckoutLoginComponent_Template_form_ngSubmit_0_listener() {
              return ctx.onSubmit();
            });
            i0.ɵɵelement(1, "cx-form-required-legend");
            i0.ɵɵelementStart(2, "div", 1)(3, "label")(4, "span", 2);
            i0.ɵɵtext(5);
            i0.ɵɵpipe(6, "cxTranslate");
            i0.ɵɵelement(7, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(8, "input", 3);
            i0.ɵɵpipe(9, "cxTranslate");
            i0.ɵɵtemplate(10, CheckoutLoginComponent_cx_form_errors_10_Template, 2, 6, "cx-form-errors", 4)(11, CheckoutLoginComponent_cx_form_errors_11_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 1)(13, "label")(14, "span", 2);
            i0.ɵɵtext(15);
            i0.ɵɵpipe(16, "cxTranslate");
            i0.ɵɵelement(17, "cx-form-required-asterisks");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(18, "input", 6);
            i0.ɵɵpipe(19, "cxTranslate");
            i0.ɵɵtemplate(20, CheckoutLoginComponent_cx_form_errors_20_Template, 2, 6, "cx-form-errors", 7)(21, CheckoutLoginComponent_cx_form_errors_21_Template, 1, 1, "cx-form-errors", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "button", 8);
            i0.ɵɵtext(23);
            i0.ɵɵpipe(24, "cxTranslate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_3_0;
            let tmp_9_0;
            i0.ɵɵproperty("formGroup", ctx.checkoutLoginForm);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 14, "checkoutLogin.emailAddress.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(9, 16, "checkoutLogin.emailAddress.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_3_0 = ctx.checkoutLoginForm.get("email")) == null ? null : tmp_3_0.touched) && ((tmp_3_0 = ctx.checkoutLoginForm.get("email")) == null ? null : tmp_3_0.invalid))("aria-errormessage", "emailError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(16, 18, "checkoutLogin.confirmEmail.label"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 20, "checkoutLogin.confirmEmail.placeholder"));
            i0.ɵɵattribute("aria-invalid", ((tmp_9_0 = ctx.checkoutLoginForm.get("emailConfirmation")) == null ? null : tmp_9_0.touched) && ((tmp_9_0 = ctx.checkoutLoginForm.get("emailConfirmation")) == null ? null : tmp_9_0.invalid))("aria-errormessage", "emailConfirmationError");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cxFeature", "formErrorsDescriptiveMessages");
            i0.ɵɵadvance();
            i0.ɵɵproperty("cxFeature", "!formErrorsDescriptiveMessages");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(24, 22, "checkoutLogin.continue"), " ");
          }
        },
        dependencies: [i3$1.ɵNgNoValidate, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.RequiredValidator, i3$1.FormGroupDirective, i3$1.FormControlName, i4.FormErrorsComponent, i1$1.FeatureDirective, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i1$1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return CheckoutLoginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutLoginModule = /*#__PURE__*/(() => {
  class CheckoutLoginModule {
    static {
      this.ɵfac = function CheckoutLoginModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutLoginModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutLoginModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            GuestCheckoutLoginComponent: {
              component: CheckoutLoginComponent,
              guards: [NotCheckoutAuthGuard]
            }
          }
        })],
        imports: [CommonModule, I18nModule, FormsModule, ReactiveFormsModule, FormErrorsModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return CheckoutLoginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutGuard = /*#__PURE__*/(() => {
  class CheckoutGuard {
    constructor(router, routingConfigService, checkoutConfigService, expressCheckoutService, activeCartFacade, checkoutStepService) {
      this.router = router;
      this.routingConfigService = routingConfigService;
      this.checkoutConfigService = checkoutConfigService;
      this.expressCheckoutService = expressCheckoutService;
      this.activeCartFacade = activeCartFacade;
      this.checkoutStepService = checkoutStepService;
      this.firstStep$ = this.checkoutStepService.steps$.pipe(map(steps => {
        return this.router.parseUrl(this.routingConfigService.getRouteConfig(steps[0]?.routeName)?.paths?.[0]);
      }));
    }
    canActivate() {
      const expressCheckout$ = this.expressCheckoutService.trySetDefaultCheckoutDetails().pipe(switchMap(expressCheckoutPossible => {
        const reviewOrderRoute = this.checkoutStepService.getCheckoutStepRoute(CheckoutStepType.REVIEW_ORDER);
        return expressCheckoutPossible && reviewOrderRoute ? of(this.router.parseUrl(this.routingConfigService.getRouteConfig(reviewOrderRoute)?.paths?.[0])) : this.firstStep$;
      }));
      return this.activeCartFacade.isGuestCart().pipe(switchMap(isGuestCart => this.checkoutConfigService.isExpressCheckout() && !isGuestCart ? expressCheckout$ : this.firstStep$));
    }
    static {
      this.ɵfac = function CheckoutGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutGuard)(i0.ɵɵinject(i3.Router), i0.ɵɵinject(i1$1.RoutingConfigService), i0.ɵɵinject(CheckoutConfigService), i0.ɵɵinject(ExpressCheckoutService), i0.ɵɵinject(i1.ActiveCartFacade), i0.ɵɵinject(CheckoutStepService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutGuard,
        factory: CheckoutGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutOrchestratorComponent = /*#__PURE__*/(() => {
  class CheckoutOrchestratorComponent {
    constructor() {
      // Intentional empty constructor
    }
    static {
      this.ɵfac = function CheckoutOrchestratorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutOrchestratorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutOrchestratorComponent,
        selectors: [["cx-checkout-orchestrator"]],
        standalone: false,
        decls: 0,
        vars: 0,
        template: function CheckoutOrchestratorComponent_Template(rf, ctx) {},
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutOrchestratorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutOrchestratorModule = /*#__PURE__*/(() => {
  class CheckoutOrchestratorModule {
    static {
      this.ɵfac = function CheckoutOrchestratorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutOrchestratorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutOrchestratorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutOrchestrator: {
              component: CheckoutOrchestratorComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutGuard]
            }
          }
        })],
        imports: [CommonModule]
      });
    }
  }
  return CheckoutOrchestratorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutOrderSummaryComponent = /*#__PURE__*/(() => {
  class CheckoutOrderSummaryComponent {
    constructor(activeCartFacade) {
      this.activeCartFacade = activeCartFacade;
      this.cartOutlets = CartOutlets;
      this.cart$ = this.activeCartFacade.getActive();
    }
    static {
      this.ɵfac = function CheckoutOrderSummaryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutOrderSummaryComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutOrderSummaryComponent,
        selectors: [["cx-checkout-order-summary"]],
        standalone: false,
        decls: 2,
        vars: 4,
        consts: [[3, "cxOutlet", "cxOutletContext"]],
        template: function CheckoutOrderSummaryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutOrderSummaryComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("cxOutlet", ctx.cartOutlets.ORDER_SUMMARY)("cxOutletContext", i0.ɵɵpipeBind1(1, 2, ctx.cart$));
          }
        },
        dependencies: [i4.OutletDirective, i2$1.AsyncPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutOrderSummaryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutOrderSummaryModule = /*#__PURE__*/(() => {
  class CheckoutOrderSummaryModule {
    static {
      this.ɵfac = function CheckoutOrderSummaryModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutOrderSummaryModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutOrderSummaryModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutOrderSummary: {
              component: CheckoutOrderSummaryComponent
            }
          }
        })],
        imports: [CommonModule, OutletModule]
      });
    }
  }
  return CheckoutOrderSummaryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutBillingAddressFormService = /*#__PURE__*/(() => {
  class CheckoutBillingAddressFormService {
    constructor() {
      this.fb = inject(UntypedFormBuilder);
      this.billingAddress = undefined;
    }
    getBillingAddressForm() {
      if (!this.form) {
        this.form = this.fb.group({
          firstName: ['', Validators.required],
          lastName: ['', Validators.required],
          line1: ['', Validators.required],
          line2: [''],
          town: ['', Validators.required],
          region: this.fb.group({
            isocodeShort: [null, Validators.required]
          }),
          country: this.fb.group({
            isocode: [null, Validators.required]
          }),
          postalCode: ['', Validators.required]
        });
      }
      return this.form;
    }
    setDeliveryAddressAsBillingAddress(address) {
      this.billingAddress = address;
    }
    isBillingAddressSameAsDeliveryAddress() {
      if (this.billingAddress === undefined) {
        return false;
      }
      return true;
    }
    isBillingAddressFormValid() {
      return this.getBillingAddressForm().valid;
    }
    markAllAsTouched() {
      this.getBillingAddressForm().markAllAsTouched();
    }
    getBillingAddress() {
      if (this.billingAddress) {
        // billing address same as delivery address
        return this.billingAddress;
      } else {
        // billing address and delivery address are different
        return this.getBillingAddressForm().value;
      }
    }
    static {
      this.ɵfac = function CheckoutBillingAddressFormService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutBillingAddressFormService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutBillingAddressFormService,
        factory: CheckoutBillingAddressFormService.ɵfac
      });
    }
  }
  return CheckoutBillingAddressFormService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutBillingAddressFormComponent = /*#__PURE__*/(() => {
  class CheckoutBillingAddressFormComponent {
    constructor() {
      this.sameAsDeliveryAddress = true;
      this.selectedCountry$ = new BehaviorSubject('');
      this.checkoutDeliveryAddressFacade = inject(CheckoutDeliveryAddressFacade);
      this.userPaymentService = inject(UserPaymentService);
      this.globalMessageService = inject(GlobalMessageService);
      this.userAddressService = inject(UserAddressService);
      this.launchDialogService = inject(LaunchDialogService);
      this.translationService = inject(TranslationService);
      this.billingAddressFormService = inject(CheckoutBillingAddressFormService);
      this.billingAddressForm = this.billingAddressFormService.getBillingAddressForm();
    }
    ngOnInit() {
      this.countries$ = this.userPaymentService.getAllBillingCountries().pipe(tap$1(countries => {
        // If the store is empty fetch countries. This is also used when changing language.
        if (Object.keys(countries).length === 0) {
          this.userPaymentService.loadBillingCountries();
        }
      }));
      this.deliveryAddress$ = this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(filter$1(state => !state.loading), map$1(state => {
        this.billingAddressFormService.setDeliveryAddressAsBillingAddress(state.data);
        return state.data;
      }));
      this.showSameAsDeliveryAddressCheckbox$ = combineLatest([this.countries$, this.deliveryAddress$]).pipe(map$1(([countries, address]) => {
        return (address?.country && !!countries.filter(country => country.isocode === address.country?.isocode).length) ?? false;
      }), tap$1(shouldShowCheckbox => {
        this.sameAsDeliveryAddress = shouldShowCheckbox;
      }));
      this.regions$ = this.selectedCountry$.pipe(switchMap$1(country => this.userAddressService.getRegions(country)), tap$1(regions => {
        const regionControl = this.billingAddressForm.get('region.isocodeShort');
        if (regions.length > 0) {
          regionControl?.enable();
        } else {
          regionControl?.disable();
        }
      }));
    }
    toggleSameAsDeliveryAddress() {
      this.sameAsDeliveryAddress = !this.sameAsDeliveryAddress;
      if (this.sameAsDeliveryAddress) {
        this.deliveryAddress$.subscribe(address => {
          this.billingAddressFormService.setDeliveryAddressAsBillingAddress(address);
        });
      } else {
        this.billingAddressFormService.setDeliveryAddressAsBillingAddress(undefined);
      }
    }
    /**
     *TODO: This method is not used, but should be. It triggers suggested addresses modal under the hood.
     *
     * See ticket CXSPA-1276
     */
    verifyAddress() {
      if (!this.sameAsDeliveryAddress) {
        this.userAddressService.verifyAddress(this.billingAddressForm.value).subscribe(result => {
          this.handleAddressVerificationResults(result);
        });
      }
    }
    handleAddressVerificationResults(results) {
      if (results.decision === 'ACCEPT') {
        //continue
      } else if (results.decision === 'REJECT') {
        this.globalMessageService.add({
          key: 'addressForm.invalidAddress'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      } else if (results.decision === 'REVIEW') {
        this.openSuggestedAddress(results);
      }
    }
    countrySelected(country) {
      this.billingAddressForm.get('country.isocode')?.setValue(country.isocode);
      this.selectedCountry$.next(country.isocode);
    }
    //TODO: Add elementRef to trigger button when verifyAddress is used.
    openSuggestedAddress(results) {
      this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.SUGGESTED_ADDRESSES, undefined, {
        enteredAddress: this.billingAddressForm.value,
        suggestedAddresses: results.suggestedAddresses
      });
      //TODO: Add logic that handle dialog's actions. Scope of CXSPA-1276
    }
    getAddressCardContent(address) {
      return this.translationService ? combineLatest([this.translationService.translate('addressCard.phoneNumber'), this.translationService.translate('addressCard.mobileNumber')]).pipe(map$1(([textPhone, textMobile]) => {
        let region = '';
        if (address.region && address.region.isocode) {
          region = address.region.isocode + ', ';
        }
        const numbers = getAddressNumbers(address, textPhone, textMobile);
        return {
          textBold: address.firstName + ' ' + address.lastName,
          text: [address.line1, address.line2, address.town + ', ' + region + address.country?.isocode, address.postalCode, numbers]
        };
      })) : EMPTY;
    }
    static {
      this.ɵfac = function CheckoutBillingAddressFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutBillingAddressFormComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutBillingAddressFormComponent,
        selectors: [["cx-checkout-billing-address-form"]],
        standalone: false,
        decls: 10,
        vars: 10,
        consts: [["billingAddress", ""], [1, "cx-payment-form-billing"], [1, "cx-payment-form-billing-address"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], [1, "form-group"], [1, "form-check"], ["type", "checkbox", 1, "form-check-input", 3, "change", "checked"], [1, "form-check-label"], [3, "content"], [3, "formGroup"], ["formGroupName", "country", 1, "form-group"], [1, "label-content", "required"], ["required", "true", "type", "text", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", 3, "control"], ["required", "true", "type", "text", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", 3, "control"], ["required", "true", "type", "text", "formControlName", "line1", 1, "form-control", 3, "placeholder"], ["id", "line1Error", 3, "control"], [1, "label-content"], ["type", "text", "formControlName", "line2", 1, "form-control", 3, "placeholder"], [1, "row"], [1, "form-group", "col-md-6"], ["required", "true", "type", "text", "formControlName", "town", 1, "form-control", 3, "placeholder"], ["id", "townError", 3, "control"], ["required", "true", "type", "text", "formControlName", "postalCode", 1, "form-control", 3, "placeholder"], ["id", "postalCodeError", 3, "control"], ["formGroupName", "region", 4, "ngIf"], ["bindLabel", "name", "bindValue", "isocode", "formControlName", "isocode", "id", "country-payment-select", 3, "change", "inputAttrs", "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], ["id", "isocodeError", 3, "control"], ["formGroupName", "region"], ["formControlName", "isocodeShort", "id", "region-select", 1, "region-select", 3, "inputAttrs", "searchable", "clearable", "items", "bindLabel", "bindValue", "placeholder", "cxNgSelectA11y"], ["id", "isocodeShortError", 3, "control"]],
        template: function CheckoutBillingAddressFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, CheckoutBillingAddressFormComponent_ng_container_4_Template, 9, 7, "ng-container", 3);
            i0.ɵɵpipe(5, "async");
            i0.ɵɵtemplate(6, CheckoutBillingAddressFormComponent_ng_container_6_Template, 2, 1, "ng-container", 4);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵtemplate(8, CheckoutBillingAddressFormComponent_ng_template_8_Template, 60, 58, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const billingAddress_r7 = i0.ɵɵreference(9);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "paymentForm.billingAddress"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 6, ctx.showSameAsDeliveryAddressCheckbox$));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.sameAsDeliveryAddress && i0.ɵɵpipeBind1(7, 8, ctx.deliveryAddress$))("ngIfElse", billingAddress_r7);
          }
        },
        dependencies: [i4.NgSelectA11yDirective, i2$1.NgIf, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.RequiredValidator, i3$1.FormGroupDirective, i3$1.FormControlName, i3$1.FormGroupName, i4$1.NgSelectComponent, i4.CardComponent, i4.FormErrorsComponent, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i1$1.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return CheckoutBillingAddressFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutBillingAddressFormModule = /*#__PURE__*/(() => {
  class CheckoutBillingAddressFormModule {
    static {
      this.ɵfac = function CheckoutBillingAddressFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutBillingAddressFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutBillingAddressFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [CheckoutBillingAddressFormService],
        imports: [NgSelectA11yModule, CommonModule, ReactiveFormsModule, NgSelectModule, CardModule, I18nModule, IconModule, SpinnerModule, FormErrorsModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return CheckoutBillingAddressFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPaymentFormComponent = /*#__PURE__*/(() => {
  class CheckoutPaymentFormComponent {
    constructor(checkoutPaymentFacade, checkoutDeliveryAddressFacade, userPaymentService, globalMessageService, fb, userAddressService, launchDialogService, translationService) {
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.userPaymentService = userPaymentService;
      this.globalMessageService = globalMessageService;
      this.fb = fb;
      this.userAddressService = userAddressService;
      this.launchDialogService = launchDialogService;
      this.translationService = translationService;
      this.iconTypes = ICON_TYPE;
      this.months = [];
      this.years = [];
      /**
       * @deprecated since 2211.25
       * Use CheckoutBillingAddressFormComponent instead
       */
      this.sameAsDeliveryAddress = true;
      /**
       * @deprecated since 2211.25
       * Use CheckoutBillingAddressFormComponent instead
       */
      this.selectedCountry$ = new BehaviorSubject('');
      this.goBack = new EventEmitter();
      this.closeForm = new EventEmitter();
      this.setPaymentDetails = new EventEmitter();
      this.paymentForm = this.fb.group({
        cardType: this.fb.group({
          code: [null, Validators.required]
        }),
        accountHolderName: ['', Validators.required],
        cardNumber: ['', Validators.required],
        expiryMonth: [null, Validators.required],
        expiryYear: [null, Validators.required],
        cvn: ['', Validators.required],
        defaultPayment: [false]
      });
      /**
       * @deprecated since 2211.25
       * Use CheckoutBillingAddressFormComponent instead
       */
      this.billingAddressForm = this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        line1: ['', Validators.required],
        line2: [''],
        town: ['', Validators.required],
        region: this.fb.group({
          isocodeShort: [null, Validators.required]
        }),
        country: this.fb.group({
          isocode: [null, Validators.required]
        }),
        postalCode: ['', Validators.required]
      });
      this.featureConfig = inject(FeatureConfigService);
      this.billingAddressService = inject(CheckoutBillingAddressFormService);
      this.useExtractedBillingAddressComponent = this.featureConfig.isEnabled('useExtractedBillingAddressComponent');
    }
    ngOnInit() {
      if (this.paymentDetails) {
        this.paymentForm.patchValue(this.paymentDetails);
      }
      this.expMonthAndYear();
      this.countries$ = this.userPaymentService.getAllBillingCountries().pipe(tap(countries => {
        // If the store is empty fetch countries. This is also used when changing language.
        if (Object.keys(countries).length === 0) {
          this.userPaymentService.loadBillingCountries();
        }
      }));
      this.cardTypes$ = this.checkoutPaymentFacade.getPaymentCardTypes();
      this.deliveryAddress$ = this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(filter(state => !state.loading), map(state => state.data));
      this.showSameAsDeliveryAddressCheckbox$ = combineLatest([this.countries$, this.deliveryAddress$]).pipe(map(([countries, address]) => {
        return (address?.country && !!countries.filter(country => country.isocode === address.country?.isocode).length) ?? false;
      }), tap(shouldShowCheckbox => {
        this.sameAsDeliveryAddress = shouldShowCheckbox;
      }));
      this.regions$ = this.selectedCountry$.pipe(switchMap(country => this.userAddressService.getRegions(country)), tap(regions => {
        const regionControl = this.billingAddressForm.get('region.isocodeShort');
        if (regions.length > 0) {
          regionControl?.enable();
        } else {
          regionControl?.disable();
        }
      }));
    }
    expMonthAndYear() {
      const year = new Date().getFullYear();
      for (let i = 0; i < 10; i++) {
        this.years.push(year + i);
      }
      for (let j = 1; j <= 12; j++) {
        if (j < 10) {
          this.months.push(`0${j}`);
        } else {
          this.months.push(j.toString());
        }
      }
    }
    toggleDefaultPaymentMethod() {
      this.paymentForm.value.defaultPayment = !this.paymentForm.value.defaultPayment;
    }
    /**
     * @deprecated since 2211.25
     * Use CheckoutBillingAddressFormComponent instead
     */
    toggleSameAsDeliveryAddress() {
      this.sameAsDeliveryAddress = !this.sameAsDeliveryAddress;
    }
    /**
     * @deprecated since 2211.25
     * Use CheckoutBillingAddressFormComponent instead
     */
    getAddressCardContent(address) {
      return this.translationService ? combineLatest([this.translationService.translate('addressCard.phoneNumber'), this.translationService.translate('addressCard.mobileNumber')]).pipe(map(([textPhone, textMobile]) => {
        let region = '';
        if (address.region && address.region.isocode) {
          region = address.region.isocode + ', ';
        }
        const numbers = getAddressNumbers(address, textPhone, textMobile);
        return {
          textBold: address.firstName + ' ' + address.lastName,
          text: [address.line1, address.line2, address.town + ', ' + region + address.country?.isocode, address.postalCode, numbers]
        };
      })) : EMPTY;
    }
    /**
     * @deprecated since 2211.25
     * Use CheckoutBillingAddressFormComponent instead
     */
    //TODO: Add elementRef to trigger button when verifyAddress is used.
    openSuggestedAddress(results) {
      this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.SUGGESTED_ADDRESSES, undefined, {
        enteredAddress: this.billingAddressForm.value,
        suggestedAddresses: results.suggestedAddresses
      });
      //TODO: Add logic that handle dialog's actions. Scope of CXSPA-1276
    }
    close() {
      this.closeForm.emit();
    }
    back() {
      this.goBack.emit();
    }
    /**
     *TODO: This method is not used, but should be. It triggers suggested addresses modal under the hood.
     *
     * See ticket CXSPA-1276
     */
    /**
     * @deprecated since 2211.25
     * Use CheckoutBillingAddressFormComponent instead
     */
    verifyAddress() {
      if (this.sameAsDeliveryAddress) {
        this.next();
      } else {
        this.userAddressService.verifyAddress(this.billingAddressForm.value).subscribe(result => {
          this.handleAddressVerificationResults(result);
        });
      }
    }
    /**
     * @deprecated since 2211.25
     * Use CheckoutBillingAddressFormComponent instead
     */
    handleAddressVerificationResults(results) {
      if (results.decision === 'ACCEPT') {
        this.next();
      } else if (results.decision === 'REJECT') {
        this.globalMessageService.add({
          key: 'addressForm.invalidAddress'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      } else if (results.decision === 'REVIEW') {
        this.openSuggestedAddress(results);
      }
    }
    /**
     * @deprecated since 2211.25
     * Use CheckoutBillingAddressFormComponent instead
     */
    countrySelected(country) {
      this.billingAddressForm.get('country.isocode')?.setValue(country.isocode);
      this.selectedCountry$.next(country.isocode);
    }
    next() {
      const sameAsDeliveryAddress = this.useExtractedBillingAddressComponent ? this.billingAddressService.isBillingAddressSameAsDeliveryAddress() : this.sameAsDeliveryAddress;
      const isBillingAddressFormValid = this.useExtractedBillingAddressComponent ? this.billingAddressService.isBillingAddressFormValid() : this.billingAddressForm.valid;
      const billingAddressFormvalue = this.useExtractedBillingAddressComponent ? this.billingAddressService.getBillingAddress() : this.billingAddressForm.value;
      if (this.paymentForm.valid) {
        if (sameAsDeliveryAddress) {
          this.setPaymentDetails.emit({
            paymentDetails: this.paymentForm.value,
            billingAddress: null
          });
        } else {
          if (isBillingAddressFormValid) {
            this.setPaymentDetails.emit({
              paymentDetails: this.paymentForm.value,
              billingAddress: billingAddressFormvalue
            });
          } else {
            this.useExtractedBillingAddressComponent ? this.billingAddressService.markAllAsTouched() : this.billingAddressForm.markAllAsTouched();
          }
        }
      } else {
        this.paymentForm.markAllAsTouched();
        this.globalMessageService.add({
          key: 'formErrors.globalMessage'
        }, GlobalMessageType.MSG_TYPE_ASSISTIVE);
        if (!sameAsDeliveryAddress) {
          this.useExtractedBillingAddressComponent ? this.billingAddressService.markAllAsTouched() : this.billingAddressForm.markAllAsTouched();
        }
      }
    }
    static {
      this.ɵfac = function CheckoutPaymentFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPaymentFormComponent)(i0.ɵɵdirectiveInject(i2.CheckoutPaymentFacade), i0.ɵɵdirectiveInject(i2.CheckoutDeliveryAddressFacade), i0.ɵɵdirectiveInject(i1$1.UserPaymentService), i0.ɵɵdirectiveInject(i1$1.GlobalMessageService), i0.ɵɵdirectiveInject(i3$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i1$1.UserAddressService), i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i1$1.TranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutPaymentFormComponent,
        selectors: [["cx-payment-form"]],
        inputs: {
          loading: "loading",
          setAsDefaultField: "setAsDefaultField",
          paymentMethodsCount: "paymentMethodsCount",
          paymentDetails: "paymentDetails"
        },
        outputs: {
          goBack: "goBack",
          closeForm: "closeForm",
          setPaymentDetails: "setPaymentDetails"
        },
        standalone: false,
        decls: 5,
        vars: 2,
        consts: [["spinner", ""], ["showExtractedBillingAddressForm", ""], ["billingAddress", ""], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [3, "ngSubmit", "formGroup"], [1, "row"], [1, "col-md-12", "col-xl-10"], ["formGroupName", "cardType", 1, "form-group"], [4, "ngIf"], [1, "form-group"], [1, "label-content"], ["required", "true", "type", "text", "formControlName", "accountHolderName", 1, "form-control", 3, "placeholder"], ["id", "accountHolderNameError", 3, "translationParams", "control", 4, "cxFeature"], [3, "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "cardNumber", 1, "form-control"], ["id", "cardNumberError", 3, "translationParams", "control", 4, "cxFeature"], [1, "form-group", "col-md-8"], [1, "cx-payment-form-exp-date"], [1, "cx-payment-form-exp-date-wrapper"], ["formControlName", "expiryMonth", "id", "month-select", 3, "inputAttrs", "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], [3, "translationParams", "control", 4, "cxFeature"], ["id", "year-select", "formControlName", "expiryYear", 3, "inputAttrs", "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], [1, "form-group", "col-md-4"], ["placement", "right", "alt", "", 1, "cx-payment-form-tooltip", 3, "type", "title"], ["required", "true", "type", "text", "id", "cVVNumber", "formControlName", "cvn", 1, "form-control"], ["id", "cvnError", 3, "translationParams", "control", 4, "cxFeature"], ["class", "form-group", 4, "ngIf"], ["class", "cx-payment-form-billing", 4, "ngIf", "ngIfElse"], [1, "cx-checkout-btns", "row"], [1, "col-md-12", "col-lg-6"], ["class", "btn btn-block btn-secondary", 3, "click", 4, "ngIf"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"], ["role", "status"], [1, "label-content", "required"], ["bindLabel", "name", "bindValue", "code", "formControlName", "code", "id", "card-type-select", 3, "inputAttrs", "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], [3, "translationParams", "control"], [3, "control"], ["id", "accountHolderNameError", 3, "translationParams", "control"], ["id", "cardNumberError", 3, "translationParams", "control"], ["id", "cvnError", 3, "translationParams", "control"], [1, "form-check"], ["type", "checkbox", 1, "form-check-input", 3, "change"], [1, "form-check-label"], [1, "cx-payment-form-billing"], [1, "cx-payment-form-billing-address"], ["type", "checkbox", 1, "form-check-input", 3, "change", "checked"], [3, "content"], [3, "formGroup"], ["formGroupName", "country", 1, "form-group"], ["required", "true", "type", "text", "formControlName", "firstName", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "line1", 1, "form-control", 3, "placeholder"], ["id", "line1Error", 3, "translationParams", "control", 4, "cxFeature"], ["type", "text", "formControlName", "line2", 1, "form-control", 3, "placeholder"], [1, "form-group", "col-md-6"], ["required", "true", "type", "text", "formControlName", "town", 1, "form-control", 3, "placeholder"], ["id", "townError", 3, "translationParams", "control", 4, "cxFeature"], ["required", "true", "type", "text", "formControlName", "postalCode", 1, "form-control", 3, "placeholder"], ["id", "postalCodeError", 3, "translationParams", "control", 4, "cxFeature"], ["formGroupName", "region", 4, "ngIf"], ["bindLabel", "name", "bindValue", "isocode", "formControlName", "isocode", "id", "country-payment-select", 3, "change", "inputAttrs", "searchable", "clearable", "items", "placeholder", "cxNgSelectA11y"], ["id", "firstNameError", 3, "translationParams", "control"], ["id", "lastNameError", 3, "translationParams", "control"], ["id", "line1Error", 3, "translationParams", "control"], ["id", "townError", 3, "translationParams", "control"], ["id", "postalCodeError", 3, "translationParams", "control"], ["formGroupName", "region"], ["formControlName", "isocodeShort", "id", "region-select", 1, "region-select", 3, "inputAttrs", "searchable", "clearable", "items", "bindLabel", "bindValue", "placeholder", "cxNgSelectA11y"], [1, "btn", "btn-block", "btn-secondary", 3, "click"]],
        template: function CheckoutPaymentFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutPaymentFormComponent_ng_container_0_Template, 69, 83, "ng-container", 3)(1, CheckoutPaymentFormComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, CheckoutPaymentFormComponent_ng_template_3_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const spinner_r14 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", spinner_r14);
          }
        },
        dependencies: [i4.NgSelectA11yDirective, i2$1.NgIf, i3$1.ɵNgNoValidate, i3$1.DefaultValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.RequiredValidator, i3$1.FormGroupDirective, i3$1.FormControlName, i3$1.FormGroupName, i4$1.NgSelectComponent, i4.CardComponent, i4.IconComponent, i4.SpinnerComponent, i4.FormErrorsComponent, i1$1.FeatureDirective, CheckoutBillingAddressFormComponent, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i1$1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutPaymentFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPaymentFormModule = /*#__PURE__*/(() => {
  class CheckoutPaymentFormModule {
    static {
      this.ɵfac = function CheckoutPaymentFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPaymentFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutPaymentFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [NgSelectA11yModule, CommonModule, ReactiveFormsModule, NgSelectModule, CardModule, I18nModule, IconModule, SpinnerModule, FormErrorsModule, FeaturesConfigModule, CheckoutBillingAddressFormModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return CheckoutPaymentFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPaymentMethodComponent = /*#__PURE__*/(() => {
  class CheckoutPaymentMethodComponent {
    get backBtnText() {
      return this.checkoutStepService.getBackBntText(this.activatedRoute);
    }
    get existingPaymentMethods$() {
      return this.userPaymentService.getPaymentMethods();
    }
    get selectedMethod$() {
      return this.checkoutPaymentFacade.getPaymentDetailsState().pipe(filter(state => !state.loading), map(state => state.data), distinctUntilChanged((prev, curr) => prev?.id === curr?.id));
    }
    constructor(userPaymentService, checkoutDeliveryAddressFacade, checkoutPaymentFacade, activatedRoute, translationService, activeCartFacade, checkoutStepService, globalMessageService) {
      this.userPaymentService = userPaymentService;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.activatedRoute = activatedRoute;
      this.translationService = translationService;
      this.activeCartFacade = activeCartFacade;
      this.checkoutStepService = checkoutStepService;
      this.globalMessageService = globalMessageService;
      this.subscriptions = new Subscription();
      this.busy$ = new BehaviorSubject(false);
      this.featureConfigService = inject(FeatureConfigService, {
        optional: true
      });
      this.focusService = inject(SelectFocusUtility);
      this.windowRef = inject(WindowRef);
      this.iconTypes = ICON_TYPE;
      this.isGuestCheckout = false;
      this.newPaymentFormManuallyOpened = false;
      this.doneAutoSelect = false;
      this.isUpdating$ = combineLatest([this.busy$, this.userPaymentService.getPaymentMethodsLoading(), this.checkoutPaymentFacade.getPaymentDetailsState().pipe(map(state => state.loading))]).pipe(map(([busy, userPaymentLoading, paymentMethodLoading]) => busy || userPaymentLoading || paymentMethodLoading), distinctUntilChanged());
    }
    ngOnInit() {
      if (!getLastValueSync(this.activeCartFacade.isGuestCart())) {
        this.userPaymentService.loadPaymentMethods();
      } else {
        this.isGuestCheckout = true;
      }
      this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(filter(state => !state.loading), take(1), map(state => state.data)).subscribe(address => {
        this.deliveryAddress = address;
      });
      this.cards$ = combineLatest([this.existingPaymentMethods$.pipe(switchMap(methods => {
        return !methods?.length ? of([]) : combineLatest(methods.map(method => combineLatest([of(method), this.translationService.translate('paymentCard.expires', {
          month: method.expiryMonth,
          year: method.expiryYear
        })]).pipe(map(([payment, translation]) => ({
          payment,
          expiryTranslation: translation
        })))));
      })), this.selectedMethod$, this.translationService.translate('paymentForm.useThisPayment'), this.translationService.translate('paymentCard.defaultPaymentMethod'), this.featureConfigService?.isEnabled('a11ySelectLabelWithContextForSelectedAddrOrPayment') ? this.translationService.translate('paymentCard.selectedPayment') : this.translationService.translate('paymentCard.selected')]).pipe(tap(([paymentMethods, selectedMethod]) => this.selectDefaultPaymentMethod(paymentMethods, selectedMethod)), map(([paymentMethods, selectedMethod, textUseThisPayment, textDefaultPaymentMethod, textSelected]) => paymentMethods.map(payment => ({
        content: this.createCard(payment.payment, {
          textExpires: payment.expiryTranslation,
          textUseThisPayment,
          textDefaultPaymentMethod,
          textSelected
        }, selectedMethod),
        paymentMethod: payment.payment
      }))));
    }
    selectDefaultPaymentMethod(paymentMethods, selectedMethod) {
      if (!this.doneAutoSelect && paymentMethods?.length && (!selectedMethod || Object.keys(selectedMethod).length === 0)) {
        const defaultPaymentMethod = paymentMethods.find(paymentMethod => paymentMethod.payment.defaultPayment);
        if (defaultPaymentMethod) {
          selectedMethod = defaultPaymentMethod.payment;
          this.savePaymentMethod(selectedMethod);
        }
        this.doneAutoSelect = true;
      }
    }
    selectPaymentMethod(paymentDetails) {
      if (paymentDetails?.id === getLastValueSync(this.selectedMethod$)?.id) {
        return;
      }
      this.globalMessageService.add({
        key: 'paymentMethods.paymentMethodSelected'
      }, GlobalMessageType.MSG_TYPE_INFO);
      this.savePaymentMethod(paymentDetails);
      if (this.featureConfigService?.isEnabled('a11yFocusOnCardAfterSelecting')) {
        this.focusCardAfterSelecting();
      }
    }
    /**
     * Restores the focus to the Card component after it has been selected and the checkout has finished updating.
     * The focus is lost due to DOM changes making it otherwise impossible to target elements that have been removed.
     */
    focusCardAfterSelecting() {
      const cardNodes = Array.from(this.windowRef?.document.querySelectorAll('cx-card'));
      const triggeredCard = this.windowRef?.document.activeElement?.closest('cx-card');
      if (triggeredCard) {
        const selectedCardIndex = cardNodes.indexOf(triggeredCard);
        this.isUpdating$.pipe(filter(isUpdating => !isUpdating), take(1)).subscribe(() => {
          requestAnimationFrame(() => {
            const selectedCard = this.windowRef?.document.querySelectorAll('cx-card')[selectedCardIndex];
            this.focusService.findFirstFocusable(selectedCard)?.focus();
          });
        });
      }
    }
    showNewPaymentForm() {
      this.newPaymentFormManuallyOpened = true;
    }
    hideNewPaymentForm() {
      this.newPaymentFormManuallyOpened = false;
    }
    setPaymentDetails({
      paymentDetails,
      billingAddress
    }) {
      this.paymentDetails = paymentDetails;
      const details = {
        ...paymentDetails
      };
      details.billingAddress = billingAddress ?? this.deliveryAddress;
      this.busy$.next(true);
      this.subscriptions.add(this.checkoutPaymentFacade.createPaymentDetails(details).subscribe({
        complete: () => {
          // we don't call onSuccess here, because it can cause a spinner flickering
          this.next();
        },
        error: () => {
          this.onError();
        }
      }));
    }
    next() {
      this.checkoutStepService.next(this.activatedRoute);
    }
    back() {
      this.checkoutStepService.back(this.activatedRoute);
    }
    savePaymentMethod(paymentDetails) {
      this.busy$.next(true);
      this.subscriptions.add(this.checkoutPaymentFacade.setPaymentDetails(paymentDetails).subscribe({
        complete: () => this.onSuccess(),
        error: () => this.onError()
      }));
    }
    getCardIcon(code) {
      let ccIcon;
      if (code === 'visa') {
        ccIcon = this.iconTypes.VISA;
      } else if (code === 'master' || code === 'mastercard_eurocard') {
        ccIcon = this.iconTypes.MASTER_CARD;
      } else if (code === 'diners') {
        ccIcon = this.iconTypes.DINERS_CLUB;
      } else if (code === 'amex') {
        ccIcon = this.iconTypes.AMEX;
      } else {
        ccIcon = this.iconTypes.CREDIT_CARD;
      }
      return ccIcon;
    }
    createCard(paymentDetails, cardLabels, selected) {
      // TODO: (CXSPA-6956) - Remove feature flag in next major release
      const hideSelectActionForSelected = this.featureConfigService?.isEnabled('a11yHideSelectBtnForSelectedAddrOrPayment');
      const isSelected = selected?.id === paymentDetails.id;
      const isButtonRole = this.featureConfigService?.isEnabled('a11ySelectLabelWithContextForSelectedAddrOrPayment') && !isSelected;
      const role = isButtonRole ? 'button' : 'application';
      return {
        role,
        title: paymentDetails.defaultPayment ? cardLabels.textDefaultPaymentMethod : '',
        textBold: paymentDetails.accountHolderName,
        text: [paymentDetails.cardNumber ?? '', cardLabels.textExpires],
        img: this.getCardIcon(paymentDetails.cardType?.code),
        actions: hideSelectActionForSelected && isSelected ? [] : [{
          name: cardLabels.textUseThisPayment,
          event: 'send'
        }],
        header: isSelected ? cardLabels.textSelected : undefined,
        label: paymentDetails.defaultPayment ? 'paymentCard.defaultPaymentLabel' : 'paymentCard.additionalPaymentLabel'
      };
    }
    onSuccess() {
      this.busy$.next(false);
    }
    onError() {
      this.busy$.next(false);
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    static {
      this.ɵfac = function CheckoutPaymentMethodComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPaymentMethodComponent)(i0.ɵɵdirectiveInject(i1$1.UserPaymentService), i0.ɵɵdirectiveInject(i2.CheckoutDeliveryAddressFacade), i0.ɵɵdirectiveInject(i2.CheckoutPaymentFacade), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i1$1.TranslationService), i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(CheckoutStepService), i0.ɵɵdirectiveInject(i1$1.GlobalMessageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutPaymentMethodComponent,
        selectors: [["cx-payment-method"]],
        standalone: false,
        decls: 5,
        vars: 2,
        consts: [["content", ""], ["loading", ""], ["hasExistingPaymentMethods", ""], ["newPaymentForm", ""], [4, "ngIf", "ngIfElse"], [3, "ngTemplateOutlet"], [1, "cx-checkout-title", "d-none", "d-lg-block", "d-xl-block"], [4, "ngIf"], ["role", "status", 4, "cxFeature"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["role", "status"], [1, "cx-checkout-text"], [1, "cx-checkout-btns", "cx-checkout-btns-top"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "cx-checkout-body", "row"], ["class", "cx-payment-card col-md-12 col-lg-6", 4, "ngFor", "ngForOf"], [1, "cx-checkout-btns", "cx-checkout-btns-bottom"], [1, "row", "cx-checkout-btns"], [1, "col-md-12", "col-lg-6"], [1, "btn", "btn-block", "btn-primary", 3, "click", "disabled"], [1, "cx-payment-card", "col-md-12", "col-lg-6"], [1, "cx-payment-card-inner", 3, "click"], [3, "sendCard", "border", "fitToContainer", "content", "index"], [3, "setPaymentDetails", "closeForm", "goBack", "paymentMethodsCount", "setAsDefaultField", "loading", "paymentDetails"], [1, "cx-spinner"]],
        template: function CheckoutPaymentMethodComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutPaymentMethodComponent_section_0_Template, 3, 4, "section", 4)(1, CheckoutPaymentMethodComponent_ng_template_1_Template, 5, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, CheckoutPaymentMethodComponent_ng_template_3_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const content_r1 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.featureConfigService == null ? null : ctx.featureConfigService.isEnabled("a11yCheckoutStepsLandmarks"))("ngIfElse", content_r1);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, CheckoutPaymentFormComponent, i4.CardComponent, i4.SpinnerComponent, i1$1.FeatureDirective, i2$1.AsyncPipe, i1$1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutPaymentMethodComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPaymentMethodModule = /*#__PURE__*/(() => {
  class CheckoutPaymentMethodModule {
    static {
      this.ɵfac = function CheckoutPaymentMethodModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPaymentMethodModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutPaymentMethodModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutPaymentDetails: {
              component: CheckoutPaymentMethodComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [CommonModule, RouterModule, CheckoutPaymentFormModule, CardModule, SpinnerModule, I18nModule, FeaturesConfigModule]
      });
    }
  }
  return CheckoutPaymentMethodModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPlaceOrderComponent = /*#__PURE__*/(() => {
  class CheckoutPlaceOrderComponent {
    get termsAndConditionInvalid() {
      return this.checkoutSubmitForm.invalid;
    }
    constructor(orderFacade, routingService, fb, launchDialogService, vcr) {
      this.orderFacade = orderFacade;
      this.routingService = routingService;
      this.fb = fb;
      this.launchDialogService = launchDialogService;
      this.vcr = vcr;
      this.params$ = new Observable();
      this.checkoutSubmitForm = this.fb.group({
        termsAndConditions: [false, Validators.requiredTrue]
      });
      this.currencyService = inject(CurrencyService);
      this.languageService = inject(LanguageService);
    }
    ngOnInit() {
      this.params$ = combineLatest([this.currencyService.getActive(), this.languageService.getActive()]).pipe(map$1(([currency, language]) => [currency, language]));
    }
    submitForm() {
      if (this.checkoutSubmitForm.valid) {
        this.placedOrder = this.launchDialogService.launch(LAUNCH_CALLER.PLACE_ORDER_SPINNER, this.vcr);
        this.orderFacade.placeOrder(this.checkoutSubmitForm.valid).subscribe({
          error: () => {
            if (!this.placedOrder) {
              return;
            }
            this.placedOrder.subscribe(component => {
              this.launchDialogService.clear(LAUNCH_CALLER.PLACE_ORDER_SPINNER);
              if (component) {
                component.destroy();
              }
            }).unsubscribe();
          },
          next: () => this.onSuccess()
        });
      } else {
        this.checkoutSubmitForm.markAllAsTouched();
      }
    }
    onSuccess() {
      this.routingService.go({
        cxRoute: 'orderConfirmation'
      });
    }
    ngOnDestroy() {
      this.launchDialogService.clear(LAUNCH_CALLER.PLACE_ORDER_SPINNER);
    }
    static {
      this.ɵfac = function CheckoutPlaceOrderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPlaceOrderComponent)(i0.ɵɵdirectiveInject(i1$2.OrderFacade), i0.ɵɵdirectiveInject(i1$1.RoutingService), i0.ɵɵdirectiveInject(i3$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(i4.LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutPlaceOrderComponent,
        selectors: [["cx-place-order"]],
        standalone: false,
        decls: 19,
        vars: 25,
        consts: [[1, "cx-place-order-form", "form-check", 3, "formGroup"], [1, "form-group"], ["formControlName", "termsAndConditions", "type", "checkbox", "aria-required", "true", 1, "scaled-input", "form-check-input"], [1, "form-check-label"], ["target", "_blank", "rel", "noopener noreferrer", 1, "cx-tc-link", 3, "routerLink"], ["id", "termsAndConditionsError", 3, "control"], [1, "btn", "btn-primary", "btn-block", 3, "click", "disabled", "cxAtMessage"]],
        template: function CheckoutPlaceOrderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cx-form-required-legend");
            i0.ɵɵelementStart(1, "form", 0)(2, "div", 1)(3, "label");
            i0.ɵɵelement(4, "input", 2);
            i0.ɵɵelementStart(5, "span", 3);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "cxTranslate");
            i0.ɵɵelementStart(8, "a", 4);
            i0.ɵɵpipe(9, "async");
            i0.ɵɵpipe(10, "cxUrl");
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(13, "cx-form-required-asterisks")(14, "cx-form-errors", 5);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(15, "button", 6);
            i0.ɵɵpipe(16, "cxTranslate");
            i0.ɵɵlistener("click", function CheckoutPlaceOrderComponent_Template_button_click_15_listener() {
              return ctx.submitForm();
            });
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "cxTranslate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.checkoutSubmitForm);
            i0.ɵɵadvance(3);
            i0.ɵɵattribute("aria-describedby", "termsAndConditionsError");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 9, "checkoutReview.confirmThatRead"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(10, 13, i0.ɵɵpureFunction1(23, _c7, i0.ɵɵpureFunction1(21, _c6, i0.ɵɵpipeBind1(9, 11, ctx.params$)))));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 15, "checkoutReview.termsAndConditions"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("control", ctx.checkoutSubmitForm.get("termsAndConditions"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.termsAndConditionInvalid)("cxAtMessage", i0.ɵɵpipeBind1(16, 17, "checkoutReview.orderInProcess"));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 19, "checkoutReview.placeOrder"), " ");
          }
        },
        dependencies: [i4.AtMessageDirective, i3.RouterLink, i3$1.ɵNgNoValidate, i3$1.CheckboxControlValueAccessor, i3$1.NgControlStatus, i3$1.NgControlStatusGroup, i3$1.FormGroupDirective, i3$1.FormControlName, i4.FormErrorsComponent, i4.FormRequiredAsterisksComponent, i4.FormRequiredLegendComponent, i2$1.AsyncPipe, i1$1.UrlPipe, i1$1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutPlaceOrderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultPlaceOrderSpinnerLayoutConfig = {
  launch: {
    PLACE_ORDER_SPINNER: {
      inline: true,
      component: SpinnerComponent,
      dialogType: DIALOG_TYPE.POPOVER_CENTER_BACKDROP
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPlaceOrderModule = /*#__PURE__*/(() => {
  class CheckoutPlaceOrderModule {
    static {
      this.ɵfac = function CheckoutPlaceOrderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPlaceOrderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutPlaceOrderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultPlaceOrderSpinnerLayoutConfig), provideDefaultConfig({
          cmsComponents: {
            CheckoutPlaceOrder: {
              component: CheckoutPlaceOrderComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [AtMessageModule, CommonModule, RouterModule, UrlModule, I18nModule, ReactiveFormsModule, FormErrorsModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
      });
    }
  }
  return CheckoutPlaceOrderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutStepsSetGuard = /*#__PURE__*/(() => {
  class CheckoutStepsSetGuard {
    constructor(checkoutStepService, routingConfigService, checkoutDeliveryAddressFacade, checkoutPaymentFacade, checkoutDeliveryModesFacade, router, activeCartFacade) {
      this.checkoutStepService = checkoutStepService;
      this.routingConfigService = routingConfigService;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.router = router;
      this.activeCartFacade = activeCartFacade;
      this.logger = inject(LoggerService);
      this.subscription = this.activeCartFacade.hasDeliveryItems().pipe(distinctUntilChanged()).subscribe(hasDeliveryItems => {
        this.checkoutStepService.disableEnableStep(CheckoutStepType.DELIVERY_ADDRESS, !hasDeliveryItems);
        this.checkoutStepService.disableEnableStep(CheckoutStepType.DELIVERY_MODE, !hasDeliveryItems);
        this.setStepNameMultiLine(CheckoutStepType.PAYMENT_DETAILS, hasDeliveryItems);
        this.setStepNameMultiLine(CheckoutStepType.REVIEW_ORDER, hasDeliveryItems);
      });
    }
    canActivate(route) {
      let currentIndex = -1;
      const currentRouteUrl = '/' + route.url.join('/');
      // check whether the previous step is set
      return this.checkoutStepService.steps$.pipe(take(1), switchMap(steps => {
        currentIndex = steps.findIndex(step => {
          const stepRouteUrl = `/${this.routingConfigService.getRouteConfig(step.routeName)?.paths?.[0]}`;
          return stepRouteUrl === currentRouteUrl;
        });
        // get current step
        let currentStep;
        if (currentIndex >= 0) {
          currentStep = steps[currentIndex];
        }
        if (Boolean(currentStep)) {
          return this.isStepSet(steps[currentIndex - 1]);
        } else {
          if (isDevMode()) {
            this.logger.warn(`Missing step with route '${currentRouteUrl}' in checkout configuration or this step is disabled.`);
          }
          return of(this.getUrl('checkout'));
        }
      }));
    }
    isStepSet(step) {
      if (step && !step.disabled) {
        switch (step.type[0]) {
          case CheckoutStepType.DELIVERY_ADDRESS:
            {
              return this.isDeliveryAddress(step);
            }
          case CheckoutStepType.DELIVERY_MODE:
            {
              return this.isDeliveryModeSet(step);
            }
          case CheckoutStepType.PAYMENT_DETAILS:
            {
              if (this.checkoutStepService.getCheckoutStep(CheckoutStepType.DELIVERY_MODE)?.disabled) {
                this.checkoutDeliveryModesFacade.setDeliveryMode('pickup');
              }
              return this.isPaymentDetailsSet(step);
            }
          case CheckoutStepType.REVIEW_ORDER:
            {
              break;
            }
        }
      }
      return of(true);
    }
    isDeliveryAddress(step) {
      return this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(filter(state => !state.loading), map(state => state.data), map(deliveryAddress => {
        if (deliveryAddress && Object.keys(deliveryAddress).length) {
          return true;
        } else {
          return this.getUrl(step.routeName);
        }
      }));
    }
    isDeliveryModeSet(step) {
      return this.checkoutDeliveryModesFacade.getSelectedDeliveryModeState().pipe(filter(state => !state.loading), map(state => state.data), map(mode => mode ? true : this.getUrl(step.routeName)));
    }
    isPaymentDetailsSet(step) {
      return this.checkoutPaymentFacade.getPaymentDetailsState().pipe(filter(state => !state.loading), map(state => state.data), map(paymentDetails => paymentDetails && Object.keys(paymentDetails).length !== 0 ? true : this.getUrl(step.routeName)));
    }
    getUrl(routeName) {
      return this.router.parseUrl(this.routingConfigService.getRouteConfig(routeName)?.paths?.[0]);
    }
    setStepNameMultiLine(stepType, value) {
      const step = this.checkoutStepService.getCheckoutStep(stepType);
      if (step) {
        step.nameMultiLine = value;
      }
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function CheckoutStepsSetGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutStepsSetGuard)(i0.ɵɵinject(CheckoutStepService), i0.ɵɵinject(i1$1.RoutingConfigService), i0.ɵɵinject(i2.CheckoutDeliveryAddressFacade), i0.ɵɵinject(i2.CheckoutPaymentFacade), i0.ɵɵinject(i2.CheckoutDeliveryModesFacade), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i1.ActiveCartFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutStepsSetGuard,
        factory: CheckoutStepsSetGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutStepsSetGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutProgressMobileBottomComponent = /*#__PURE__*/(() => {
  class CheckoutProgressMobileBottomComponent {
    constructor(checkoutStepService) {
      this.checkoutStepService = checkoutStepService;
      this._steps$ = this.checkoutStepService.steps$;
      this.activeStepIndex$ = this.checkoutStepService.activeStepIndex$.pipe(tap(index => this.activeStepIndex = index));
    }
    get steps$() {
      return this._steps$.asObservable();
    }
    static {
      this.ɵfac = function CheckoutProgressMobileBottomComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutProgressMobileBottomComponent)(i0.ɵɵdirectiveInject(CheckoutStepService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutProgressMobileBottomComponent,
        selectors: [["cx-checkout-progress-mobile-bottom"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [1, "cx-media"], [4, "ngFor", "ngForOf"], ["class", "cx-list-media", 4, "ngIf"], [1, "cx-list-media"]],
        template: function CheckoutProgressMobileBottomComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutProgressMobileBottomComponent_div_0_Template, 4, 3, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.activeStepIndex$) !== undefined);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$1.AsyncPipe, i1$1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutProgressMobileBottomComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutProgressMobileBottomModule = /*#__PURE__*/(() => {
  class CheckoutProgressMobileBottomModule {
    static {
      this.ɵfac = function CheckoutProgressMobileBottomModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutProgressMobileBottomModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutProgressMobileBottomModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutProgressMobileBottom: {
              component: CheckoutProgressMobileBottomComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutStepsSetGuard]
            }
          }
        })],
        imports: [CommonModule, UrlModule, I18nModule, RouterModule]
      });
    }
  }
  return CheckoutProgressMobileBottomModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutProgressMobileTopComponent = /*#__PURE__*/(() => {
  class CheckoutProgressMobileTopComponent {
    constructor(activeCartFacade, checkoutStepService) {
      this.activeCartFacade = activeCartFacade;
      this.checkoutStepService = checkoutStepService;
      this._steps$ = this.checkoutStepService.steps$;
      this.cart$ = this.activeCartFacade.getActive();
      this.activeStepIndex$ = this.checkoutStepService.activeStepIndex$.pipe(tap(index => this.activeStepIndex = index));
      useFeatureStyles('a11yTruncatedTextForResponsiveView');
    }
    get steps$() {
      return this._steps$.asObservable();
    }
    static {
      this.ɵfac = function CheckoutProgressMobileTopComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutProgressMobileTopComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(CheckoutStepService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutProgressMobileTopComponent,
        selectors: [["cx-checkout-progress-mobile-top"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [1, "cx-media"], ["class", "cx-list-media cx-title", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "cx-list-media", "cx-title"], ["class", "cx-list-media", 4, "ngIf"], ["class", "cx-list-media is-active", 4, "ngIf"], [1, "cx-list-media"], [1, "cx-title"], [1, "btn", "btn-link", 3, "routerLink"], [1, "cx-list-media", "is-active"]],
        template: function CheckoutProgressMobileTopComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutProgressMobileTopComponent_div_0_Template, 3, 3, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.activeStepIndex$) !== undefined);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.RouterLink, i2$1.AsyncPipe, i1$1.UrlPipe, i1$1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutProgressMobileTopComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutProgressMobileTopModule = /*#__PURE__*/(() => {
  class CheckoutProgressMobileTopModule {
    static {
      this.ɵfac = function CheckoutProgressMobileTopModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutProgressMobileTopModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutProgressMobileTopModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutProgressMobileTop: {
              component: CheckoutProgressMobileTopComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutStepsSetGuard]
            }
          }
        })],
        imports: [CommonModule, UrlModule, I18nModule, RouterModule]
      });
    }
  }
  return CheckoutProgressMobileTopModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let MultiLinePipe = /*#__PURE__*/(() => {
  class MultiLinePipe {
    transform(value) {
      const lastIndex = value.lastIndexOf(' ');
      if (lastIndex === -1) {
        return value;
      }
      return value.substring(0, lastIndex) + '<br />' + value.substring(lastIndex, value.length).trim();
    }
    static {
      this.ɵfac = function MultiLinePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MultiLinePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cxMultiLine",
        type: MultiLinePipe,
        pure: true,
        standalone: false
      });
    }
  }
  return MultiLinePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutProgressComponent = /*#__PURE__*/(() => {
  class CheckoutProgressComponent {
    constructor(checkoutStepService) {
      this.checkoutStepService = checkoutStepService;
      this.params$ = new Observable();
      this._steps$ = this.checkoutStepService.steps$;
      this.currencyService = inject(CurrencyService);
      this.languageService = inject(LanguageService);
      this.activeStepIndex$ = this.checkoutStepService.activeStepIndex$.pipe(tap(index => this.activeStepIndex = index));
    }
    get steps$() {
      return this._steps$.asObservable();
    }
    ngOnInit() {
      this.params$ = combineLatest([this.currencyService.getActive(), this.languageService.getActive()]).pipe(map(([currency, language]) => [currency, language]));
    }
    getTabIndex(stepIndex) {
      return !this.isActive(stepIndex) && !this.isDisabled(stepIndex) ? 0 : -1;
    }
    isActive(index) {
      return index === this.activeStepIndex;
    }
    isDisabled(index) {
      return index > this.activeStepIndex;
    }
    getStepState(index) {
      if (this.isDisabled(index)) {
        return CheckoutStepState.DISABLED;
      }
      if (this.isActive(index)) {
        return CheckoutStepState.SELECTED;
      }
      return CheckoutStepState.COMPLETED;
    }
    static {
      this.ɵfac = function CheckoutProgressComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutProgressComponent)(i0.ɵɵdirectiveInject(CheckoutStepService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutProgressComponent,
        selectors: [["cx-checkout-progress"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [1, "cx-nav", "d-none", "d-lg-block", "d-xl-block"], [1, "cx-list"], [4, "ngFor", "ngForOf"], [1, "cx-item"], [1, "cx-link", 3, "routerLink", "tabindex", "innerHTML"]],
        template: function CheckoutProgressComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutProgressComponent_nav_0_Template, 6, 6, "nav", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.activeStepIndex$) !== undefined);
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i3.RouterLink, i2$1.AsyncPipe, i1$1.UrlPipe, i1$1.TranslatePipe, MultiLinePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutProgressComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutProgressModule = /*#__PURE__*/(() => {
  class CheckoutProgressModule {
    static {
      this.ɵfac = function CheckoutProgressModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutProgressModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutProgressModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutProgress: {
              component: CheckoutProgressComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard, CheckoutStepsSetGuard]
            }
          }
        })],
        imports: [CommonModule, UrlModule, I18nModule, RouterModule]
      });
    }
  }
  return CheckoutProgressModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutReviewSubmitComponent = /*#__PURE__*/(() => {
  class CheckoutReviewSubmitComponent {
    constructor(checkoutDeliveryAddressFacade, checkoutPaymentFacade, activeCartFacade, translationService, checkoutStepService, checkoutDeliveryModesFacade) {
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.activeCartFacade = activeCartFacade;
      this.translationService = translationService;
      this.checkoutStepService = checkoutStepService;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.cartOutlets = CartOutlets;
      this.iconTypes = ICON_TYPE;
      this.checkoutStepTypeDeliveryAddress = CheckoutStepType.DELIVERY_ADDRESS;
      this.checkoutStepTypePaymentDetails = CheckoutStepType.PAYMENT_DETAILS;
      this.checkoutStepTypeDeliveryMode = CheckoutStepType.DELIVERY_MODE;
      this.promotionLocation = PromotionLocation.ActiveCart;
      this.steps$ = this.checkoutStepService.steps$;
      this.deliveryAddress$ = this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
      this.deliveryMode$ = this.checkoutDeliveryModesFacade.getSelectedDeliveryModeState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
      this.paymentDetails$ = this.checkoutPaymentFacade.getPaymentDetailsState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
    }
    get cart$() {
      return this.activeCartFacade.getActive();
    }
    get entries$() {
      return this.activeCartFacade.getEntries();
    }
    getCheckoutDeliverySteps() {
      return [CheckoutStepType.DELIVERY_ADDRESS, CheckoutStepType.DELIVERY_MODE];
    }
    getCheckoutPaymentSteps() {
      return [CheckoutStepType.PAYMENT_DETAILS, CheckoutStepType.DELIVERY_ADDRESS];
    }
    getDeliveryAddressCard(deliveryAddress, countryName) {
      return combineLatest([this.translationService.translate('addressCard.shipTo'), this.translationService.translate('addressCard.phoneNumber'), this.translationService.translate('addressCard.mobileNumber')]).pipe(map(([textTitle, textPhone, textMobile]) => deliveryAddressCard(textTitle, textPhone, textMobile, deliveryAddress, countryName)));
    }
    getDeliveryModeCard(deliveryMode) {
      return combineLatest([this.translationService.translate('checkoutMode.deliveryMethod')]).pipe(map(([textTitle]) => deliveryModeCard(textTitle, deliveryMode)));
    }
    getPaymentMethodCard(paymentDetails) {
      return combineLatest([this.translationService.translate('paymentForm.payment'), this.translationService.translate('paymentCard.expires', {
        month: paymentDetails.expiryMonth,
        year: paymentDetails.expiryYear
      }), this.translationService.translate('paymentForm.billingAddress')]).pipe(map(([textTitle, textExpires, billingAddress]) => {
        const region = paymentDetails.billingAddress?.region?.isocode ? paymentDetails.billingAddress?.region?.isocode + ', ' : '';
        return {
          title: textTitle,
          textBold: paymentDetails.accountHolderName,
          text: [paymentDetails.cardNumber, textExpires],
          paragraphs: [{
            title: billingAddress + ':',
            text: [paymentDetails.billingAddress?.firstName + ' ' + paymentDetails.billingAddress?.lastName, paymentDetails.billingAddress?.line1, paymentDetails.billingAddress?.town + ', ' + region + paymentDetails.billingAddress?.country?.isocode, paymentDetails.billingAddress?.postalCode]
          }]
        };
      }));
    }
    getCheckoutStepUrl(stepType) {
      const step = this.checkoutStepService.getCheckoutStep(stepType);
      return step?.routeName;
    }
    deliverySteps(steps) {
      return steps.filter(step => this.getCheckoutDeliverySteps().includes(step.type[0]));
    }
    paymentSteps(steps) {
      return steps.filter(step => this.getCheckoutPaymentSteps().includes(step.type[0]));
    }
    static {
      this.ɵfac = function CheckoutReviewSubmitComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReviewSubmitComponent)(i0.ɵɵdirectiveInject(i2.CheckoutDeliveryAddressFacade), i0.ɵɵdirectiveInject(i2.CheckoutPaymentFacade), i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(i1$1.TranslationService), i0.ɵɵdirectiveInject(CheckoutStepService), i0.ɵɵdirectiveInject(i2.CheckoutDeliveryModesFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutReviewSubmitComponent,
        selectors: [["cx-review-submit"]],
        standalone: false,
        decls: 15,
        vars: 9,
        consts: [["deliveryAddress", ""], ["deliveryMode", ""], ["paymentMethod", ""], [1, "cx-review"], [1, "cx-review-title", "d-none", "d-lg-block", "d-xl-block"], [1, "cx-review-summary", "row"], [4, "ngIf"], [1, "col-md-12", "col-lg-6", "col-xl-6", "cx-review-payment-col"], [4, "ngFor", "ngForOf"], [1, "col-md-12", "col-lg-6", "col-xl-6", "cx-review-shipping-col"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngTemplateOutlet"], ["class", "cx-review-summary-card cx-review-card-address", 4, "ngIf"], [1, "cx-review-summary-card", "cx-review-card-address"], [3, "content"], [1, "cx-review-summary-edit-step"], [3, "routerLink"], ["aria-hidden", "true", 3, "type"], [1, "cx-review-summary-card", "cx-review-card-shipping"], [3, "content", 4, "ngIf"], [3, "cxOutlet", "cxOutletContext"], [1, "cx-review-summary-card", "cx-review-card-payment"], [1, "cx-review-cart-total", "d-none", "d-lg-block", "d-xl-block"], [1, "cx-review-cart-heading", "d-block", "d-lg-none", "d-xl-none"], ["class", "cx-review-cart-item", 4, "ngIf"], [1, "cx-review-cart-item"], [3, "promotions"]],
        template: function CheckoutReviewSubmitComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 3)(1, "h2", 4);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 5);
            i0.ɵɵtemplate(5, CheckoutReviewSubmitComponent_ng_container_5_Template, 5, 2, "ng-container", 6);
            i0.ɵɵpipe(6, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, CheckoutReviewSubmitComponent_ng_template_7_Template, 2, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(9, CheckoutReviewSubmitComponent_ng_template_9_Template, 11, 18, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(11, CheckoutReviewSubmitComponent_ng_template_11_Template, 9, 12, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(13, CheckoutReviewSubmitComponent_ng_container_13_Template, 9, 13, "ng-container", 6);
            i0.ɵɵpipe(14, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_4_0;
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "checkoutReview.review"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", (tmp_4_0 = i0.ɵɵpipeBind1(6, 5, ctx.steps$)) == null ? null : tmp_4_0.slice(0, -1));
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(14, 7, ctx.cart$));
          }
        },
        dependencies: [i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, i2$1.NgSwitch, i2$1.NgSwitchCase, i4.CardComponent, i3.RouterLink, i4.PromotionsComponent, i4.IconComponent, i4.OutletDirective, i2$1.AsyncPipe, i1$1.TranslatePipe, i1$1.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutReviewSubmitComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutReviewSubmitModule = /*#__PURE__*/(() => {
  class CheckoutReviewSubmitModule {
    static {
      this.ɵfac = function CheckoutReviewSubmitModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReviewSubmitModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutReviewSubmitModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutReviewOrder: {
              component: CheckoutReviewSubmitComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [CommonModule, CardModule, I18nModule, UrlModule, RouterModule, PromotionsModule, IconModule, OutletModule]
      });
    }
  }
  return CheckoutReviewSubmitModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutReviewOverviewComponent = /*#__PURE__*/(() => {
  class CheckoutReviewOverviewComponent {
    constructor(activeCartFacade) {
      this.activeCartFacade = activeCartFacade;
      this.document = inject(DOCUMENT, {
        optional: true
      });
      this.translationService = inject(TranslationService, {
        optional: true
      });
      this.featureService = inject(FeatureConfigService, {
        optional: true
      });
      // These are the components that we need to wrap with section element.
      this.CHECKOUT_COMPONENTS = ['cx-checkout-review-payment', 'cx-checkout-review-overview', 'cx-checkout-review-shipping'];
    }
    ngAfterViewInit() {
      this.wrapComponentsWithSectionEl();
    }
    get cart$() {
      return this.activeCartFacade.getActive();
    }
    /**
     * Wraps checkout review components with section element required
     * for applying correct a11y practices.
     *
     * Note: We need to do it this way because there is no single parent component
     * template we can use to wrap all related components because the layout is
     * CMS-driven (ie. by page slot).
     */
    wrapComponentsWithSectionEl() {
      if (this.document && this.translationService && this.featureService?.isEnabled('a11yWrapReviewOrderInSection')) {
        this.translationService.translate('checkoutReview.reviewOrder').pipe(take$1(1)).subscribe(label => {
          // We need to delay for a tick to let components render before querying.
          requestAnimationFrame(() => {
            // Wrap checkout components with section selector.
            const els = this.CHECKOUT_COMPONENTS.map(selector => this.document?.querySelector(selector));
            const parent = els[0]?.parentNode;
            const section = this.document?.createElement('section');
            if (parent && section) {
              section.ariaLabel = label;
              parent.replaceChild(section, els[0]);
              els.forEach(el => section.appendChild(el));
            }
          });
        });
      }
    }
    static {
      this.ɵfac = function CheckoutReviewOverviewComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReviewOverviewComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutReviewOverviewComponent,
        selectors: [["cx-checkout-review-overview"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [1, "cx-review-cart-total", "d-none", "d-lg-block", "d-xl-block"], [3, "promotions"]],
        template: function CheckoutReviewOverviewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutReviewOverviewComponent_ng_container_0_Template, 5, 10, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.cart$));
          }
        },
        dependencies: [i2$1.NgIf, i4.PromotionsComponent, i2$1.AsyncPipe, i1$1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutReviewOverviewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutReviewOverviewModule = /*#__PURE__*/(() => {
  class CheckoutReviewOverviewModule {
    static {
      this.ɵfac = function CheckoutReviewOverviewModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReviewOverviewModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutReviewOverviewModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutReviewOverview: {
              component: CheckoutReviewOverviewComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [CommonModule, PromotionsModule, I18nModule]
      });
    }
  }
  return CheckoutReviewOverviewModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutReviewPaymentComponent = /*#__PURE__*/(() => {
  class CheckoutReviewPaymentComponent {
    constructor(checkoutStepService, checkoutPaymentFacade, translationService) {
      this.checkoutStepService = checkoutStepService;
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.translationService = translationService;
      this.iconTypes = ICON_TYPE;
      this.paymentDetailsStepRoute = this.checkoutStepService.getCheckoutStepRoute(CheckoutStepType.PAYMENT_DETAILS);
      this.paymentDetails$ = this.checkoutPaymentFacade.getPaymentDetailsState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
      useFeatureStyles('a11yHighContrastBorders');
    }
    getPaymentMethodCard(paymentDetails) {
      return combineLatest([this.translationService.translate('paymentForm.payment'), this.translationService.translate('paymentCard.expires', {
        month: paymentDetails.expiryMonth,
        year: paymentDetails.expiryYear
      })]).pipe(map(([textTitle, textExpires]) => paymentMethodCard(textTitle, textExpires, paymentDetails)));
    }
    getBillingAddressCard(paymentDetails) {
      return combineLatest([this.translationService.translate('paymentForm.billingAddress'), this.translationService.translate('addressCard.billTo')]).pipe(map(([billingAddress, billTo]) => billingAddressCard(billingAddress, billTo, paymentDetails)));
    }
    static {
      this.ɵfac = function CheckoutReviewPaymentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReviewPaymentComponent)(i0.ɵɵdirectiveInject(CheckoutStepService), i0.ɵɵdirectiveInject(i2.CheckoutPaymentFacade), i0.ɵɵdirectiveInject(i1$1.TranslationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutReviewPaymentComponent,
        selectors: [["cx-checkout-review-payment"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [["class", "cx-review-summary", 4, "ngIf"], [1, "cx-review-summary"], [1, "cx-review-summary-card", "cx-review-summary-payment-card"], [3, "content"], [1, "cx-review-summary-edit-step"], [3, "routerLink"], ["aria-hidden", "true", 3, "type"]],
        template: function CheckoutReviewPaymentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutReviewPaymentComponent_div_0_Template, 19, 24, "div", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.paymentDetails$));
          }
        },
        dependencies: [i2$1.NgIf, i4.CardComponent, i3.RouterLink, i4.IconComponent, i2$1.AsyncPipe, i1$1.TranslatePipe, i1$1.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutReviewPaymentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutReviewPaymentModule = /*#__PURE__*/(() => {
  class CheckoutReviewPaymentModule {
    static {
      this.ɵfac = function CheckoutReviewPaymentModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReviewPaymentModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutReviewPaymentModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutReviewPayment: {
              component: CheckoutReviewPaymentComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [CommonModule, CardModule, I18nModule, UrlModule, RouterModule, IconModule]
      });
    }
  }
  return CheckoutReviewPaymentModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutReviewShippingComponent = /*#__PURE__*/(() => {
  class CheckoutReviewShippingComponent {
    constructor(activeCartFacade, checkoutDeliveryModesFacade, checkoutDeliveryAddressFacade, translationService, checkoutStepService) {
      this.activeCartFacade = activeCartFacade;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.translationService = translationService;
      this.checkoutStepService = checkoutStepService;
      this.featureConfig = inject(FeatureConfigService);
      this.showDeliveryOptionsTranslation = this.featureConfig.isEnabled('showDeliveryOptionsTranslation');
      this.cartOutlets = CartOutlets;
      this.iconTypes = ICON_TYPE;
      this.deliveryAddressStepRoute = this.checkoutStepService.getCheckoutStepRoute(CheckoutStepType.DELIVERY_ADDRESS);
      this.deliveryModeStepRoute = this.checkoutStepService.getCheckoutStepRoute(CheckoutStepType.DELIVERY_MODE);
      this.entries$ = this.activeCartFacade.getDeliveryEntries();
      this.deliveryAddress$ = this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
      this.deliveryMode$ = this.checkoutDeliveryModesFacade.getSelectedDeliveryModeState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
    }
    getDeliveryAddressCard(deliveryAddress, countryName) {
      return combineLatest([this.translationService.translate('addressCard.shipTo'), this.translationService.translate('addressCard.phoneNumber'), this.translationService.translate('addressCard.mobileNumber')]).pipe(map(([textTitle, textPhone, textMobile]) => deliveryAddressCard(textTitle, textPhone, textMobile, deliveryAddress, countryName)));
    }
    getDeliveryModeCard(deliveryMode) {
      return combineLatest([this.translationService.translate(this.showDeliveryOptionsTranslation ? 'checkoutMode.deliveryOptions' : 'checkoutMode.deliveryMethod')]).pipe(map(([textTitle]) => deliveryModeCard(textTitle, deliveryMode)));
    }
    static {
      this.ɵfac = function CheckoutReviewShippingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReviewShippingComponent)(i0.ɵɵdirectiveInject(i1.ActiveCartFacade), i0.ɵɵdirectiveInject(i2.CheckoutDeliveryModesFacade), i0.ɵɵdirectiveInject(i2.CheckoutDeliveryAddressFacade), i0.ɵɵdirectiveInject(i1$1.TranslationService), i0.ɵɵdirectiveInject(CheckoutStepService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutReviewShippingComponent,
        selectors: [["cx-checkout-review-shipping"]],
        standalone: false,
        decls: 2,
        vars: 3,
        consts: [[4, "ngIf"], [1, "cx-review-header"], [1, "cx-review-summary", "cx-review-shipping-summary"], [1, "cx-review-summary-card-container"], ["class", "cx-review-summary-card cx-review-card-address", 4, "ngIf"], [1, "cx-review-summary-card", "cx-review-card-address"], [3, "content", 4, "ngIf"], [1, "cx-review-summary-edit-step"], [3, "routerLink"], ["aria-hidden", "true", 3, "type"], [1, "cx-review-cart-item"], [3, "cxOutlet", "cxOutletContext"], [3, "content"]],
        template: function CheckoutReviewShippingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutReviewShippingComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.entries$));
          }
        },
        dependencies: [i2$1.NgIf, i4.CardComponent, i3.RouterLink, i4.IconComponent, i4.OutletDirective, i2$1.AsyncPipe, i1$1.TranslatePipe, i1$1.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutReviewShippingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutReviewShippingModule = /*#__PURE__*/(() => {
  class CheckoutReviewShippingModule {
    static {
      this.ɵfac = function CheckoutReviewShippingModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutReviewShippingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutReviewShippingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutReviewShipping: {
              component: CheckoutReviewShippingComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [CommonModule, I18nModule, CardModule, UrlModule, RouterModule, IconModule, OutletModule]
      });
    }
  }
  return CheckoutReviewShippingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutComponentsModule = /*#__PURE__*/(() => {
  class CheckoutComponentsModule {
    static {
      this.ɵfac = function CheckoutComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CheckoutOrchestratorModule, CheckoutOrderSummaryModule, CheckoutProgressModule, CheckoutProgressMobileTopModule, CheckoutProgressMobileBottomModule, CheckoutDeliveryModeModule, CheckoutPaymentMethodModule, CheckoutPlaceOrderModule, CheckoutReviewSubmitModule, CheckoutReviewPaymentModule, CheckoutReviewShippingModule, CheckoutReviewOverviewModule, CheckoutDeliveryAddressModule, CheckoutLoginModule]
      });
    }
  }
  return CheckoutComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CartNotEmptyGuard, CheckoutAuthGuard, CheckoutBillingAddressFormComponent, CheckoutBillingAddressFormModule, CheckoutBillingAddressFormService, CheckoutComponentsModule, CheckoutConfigService, CheckoutDeliveryAddressComponent, CheckoutDeliveryAddressModule, CheckoutDeliveryModeComponent, CheckoutDeliveryModeModule, CheckoutFlowOrchestratorService, CheckoutGuard, CheckoutLoginComponent, CheckoutLoginModule, CheckoutOrchestratorComponent, CheckoutOrchestratorModule, CheckoutOrderSummaryComponent, CheckoutOrderSummaryModule, CheckoutPaymentFormComponent, CheckoutPaymentFormModule, CheckoutPaymentMethodComponent, CheckoutPaymentMethodModule, CheckoutPlaceOrderComponent, CheckoutPlaceOrderModule, CheckoutProgressComponent, CheckoutProgressMobileBottomComponent, CheckoutProgressMobileBottomModule, CheckoutProgressMobileTopComponent, CheckoutProgressMobileTopModule, CheckoutProgressModule, CheckoutReviewSubmitComponent, CheckoutReviewSubmitModule, CheckoutStepService, CheckoutStepsSetGuard, ExpressCheckoutService, NotCheckoutAuthGuard };
